// import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { init } from '../editorconfig';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
interface User {
  id: number;
  name: string;
  email: string;
  department: string;
}

@Component({
  selector: 'app-tdf-dashboard',
  standalone: false,
  templateUrl: './tdf-dashboard.component.html',
  styleUrls: ['./tdf-dashboard.component.scss']
})

export class TdfDashboardComponent {
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  challengeForm: FormGroup;
  proposalForm: FormGroup;
  uploadedFiles: any[] = [];
  apiUrl = environment.APIUrl;
  payload: any;
  @Input() id: any;
  PDSGenId: any;
  needGenData: any;
  needGenId;
  draftSotr: File;
  draftSotrFile: File | null = null;
  supportingDocsFiles: File | null = null;
  private subscriptions = new Subscription();
  @ViewChild('draftSotrUpload') draftSotrUpload!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @ViewChild('documentUpload') documentUpload!: FileUpload;
  @ViewChild('remarkPanel') remarkPanel!: OverlayPanel;
  @ViewChild('directoratePanel') directoratePanel!: OverlayPanel;
  userID: any;
  totalShortClosed: number = 0;
  stageTrackingGlobalFilter: string = '';
  stageTrackingGlobalFilterFields: string[] = ['name'];
  selectedDirectorateList: any[] = [];
  selectedRemarkFullText: string = '';
  selectedYear: number = new Date().getFullYear();
  statusCards: any[] = [];
  yearOptions: any[] = [];
  loginName: any;
  categoryOptions = [
    { label: 'To Move', value: 'To Move' },
    { label: 'To Fight', value: 'To Fight' },
    { label: 'To Float', value: 'To Float' }
  ];

  constructor(private fb: FormBuilder, private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
    this.userForm = this.fb.group({
      // startDate: ['', Validators.required],
      // endDate: ['', Validators.required],
      lastDate: ['', Validators.required],
      directorate: [[], Validators.required],
      remarks: ['', [Validators.required, Validators.maxLength(500)]],
      uploadedDocuments: [[]]
    });
    this.routeForm = this.fb.group({
      step: [null, Validators.required],
      role: [null, Validators.required],
      user: [null, Validators.required],
      unit: [null, Validators.required],
      level: [null, Validators.required],
      approved: [false],
    });
  }


  userForm: FormGroup;
  users: User[] = [
    { id: 1, name: 'John Doe', email: 'john.doe@company.com', department: 'Development' },
    { id: 2, name: 'Sarah Smith', email: 'sarah.smith@company.com', department: 'Marketing' },
    { id: 3, name: 'Mike Johnson', email: 'mike.johnson@company.com', department: 'Sales' },
    { id: 4, name: 'Emily Brown', email: 'emily.brown@company.com', department: 'HR' },
    { id: 5, name: 'David Wilson', email: 'david.wilson@company.com', department: 'Finance' }
  ];

  isLoading = false;
  isSubmitted = false;
  displayDialog: boolean = false;
  uploadedDocuments: File[] = [];
  // Proposal status tabs for work done and pending work 
  proposalStatusTabs = [
    { label: 'Work Done', status: 'initiated', active: false, tab: 1 }, // Show initiated proposals
    { label: 'Pending Work', status: 'in_review', active: false, tab: 1 }, // Show initiated proposals
  ];
   tableColumns = [
    { field: 'directorate', header: 'Directorate', filterType: 'text', filter: true },
    { field: 'name', header: 'Name', filterType: 'text', filter: true },
    { field: 'description', header: 'Description', filterType: 'text', filter: true },
    { field: 'steps', header: 'Steps', filterType: 'text' },
    { field: 'progress', header: 'Progress', filterType: 'text', filter: true },
    { field: 'proposal_status', header: 'Status', filterType: 'text', filter: true }
  ];
  currentPage: number = 1;
  activeTabIndex: number = 0;
  activePhaseId: any;
  selectedPhaseId: any;
  lazy: boolean = true;
  totalCount = 10;
  filteredRecentProposals: any[];
  proposalData = [];
  /** Proposal-wise Stage Tracking table: only from make1/dashboard/summary proposal_data (scheme_id=16). */
  stageTrackingProposalData: any[] = [];
  stageTrackingFilters = {
    name: '', current_stage: '', overall_status: '',
    aip: '', feasibility: '', aon: '', eoi_pso: '', prototype: '', ssct: '', rfp_cnc: '',
    updated_at: '', days: ''
  };
  stageTrackingSortField = '';
  stageTrackingSortOrder: 1 | -1 = 1;
  filteredStageTrackingData: any[] = [];
  stageTablePageSize = 10;
  stageTableCurrentPage = 1;
  stageTableTotalPages = 0;
  stageTableStartEntry = 0;
  stageTableEndEntry = 0;
  stageTablePaginatedData: any[] = [];
  stageTablePageSizeOptions = [5, 10, 25, 50];
  seekTableSortField = '';
  seekTableSortOrder: 1 | -1 = 1;
  seekTableFilters = {
    end_date: '', date_extended: '', remark: '', directorate: ''
  };
  seekTablePageSize = 10;
  seekTableCurrentPage = 1;
  seekTableTotalPages = 0;
  seekTableStartEntry = 0;
  seekTableEndEntry = 0;
  seekTablePaginatedData: any[] = [];
  seekTablePageSizeOptions = [5, 10, 25, 50];
  phases = [];
  schemes: any;
  // currentsubSchemeId: any;
  currentSchemeId:any;
  activeStatusTabIndex: any = this.proposalStatusTabs[0];

  onSubmittttdf(): void {
    this.isSubmitted = true;
    // Log individual field status
    Object.keys(this.userForm.controls).forEach(key => {
      const control = this.userForm.get(key);
      console.log(`${key}:`, {
        value: control?.value,
        valid: control?.valid,
        errors: control?.errors,
        touched: control?.touched,
        dirty: control?.dirty
      });
    });

    if (this.userForm.valid) {
      this.isLoading = true;

      // Create FormData to handle file uploads
      const formData = new FormData();

      // Add form fields
      formData.append('end_date', this.userForm.get('lastDate')?.value);
      formData.append('remark', this.userForm.get('remarks')?.value);
      formData.append('scheme', this.schemeID);


      // Handle directorate array - send as individual values
      const directorateIds = this.userForm.get('directorate')?.value || [];
      directorateIds.forEach((id: any) => {
        formData.append('directorate_id', id);
      });

      // Add uploaded documents using seek_file key
      this.uploadedDocuments.forEach((file: File, index: number) => {
        formData.append('seek_file', file);
      });

      console.log('Submitting FormData with documents:', this.uploadedDocuments.length);

      // Make actual API call with FormData
      const sub = this.api.postAPI('/transaction/seek/proposal/', formData).subscribe({
        next: (res: any) => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Your seek proposal request has been processed successfully!'
          });
          this.displayDialog = false;
          this.resetForm();
          this.loadSeekSummary();
        },
        error: (err: any) => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to submit proposal. Please try again.'
          });
          console.error('API Error:', err);
        }
      });
      this.subscriptions.add(sub);
    } else {
      console.log('Form is invalid, marking fields as touched');
      this.markFormGroupTouched();
    }
  }
  onSubmit(): void {
  this.isSubmitted = true;

  if (this.userForm.valid) {
    this.isLoading = true;

    const formData = new FormData();
    formData.append('start_date', this.userForm.get('startDate')?.value);
    formData.append('end_date', this.userForm.get('lastDate')?.value);
    formData.append('remark', this.userForm.get('remarks')?.value);
    formData.append('scheme', (this.schemeID ?? 16).toString());

    const directorates = this.userForm.get('directorate')?.value || [];
    directorates.forEach((id: number) => {
      formData.append('directorate_id', id.toString());
    });

    // Append files
    this.selectedFiles.forEach(file => {
      formData.append('seek_file', file, file.name);
    });

    const sub = this.api.postAPI('/transaction/seek/proposal/', formData).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Proposal submitted successfully!'
        });
        this.displayDialog = false;
        this.selectedFiles = []; // clear files
        this.resetForm();
        this.getProposalData();
      },
      error: (err: any) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.detail || 'Failed to submit proposal. Please try again.'
        });
      }
    });
    this.subscriptions.add(sub);
  } else {
      this.markFormGroupTouched();
    }
  }

  resetForm(): void {
    this.userForm.reset();
    this.userForm.patchValue({
      directorate: [],
      uploadedDocuments: []
    });
    this.uploadedDocuments = [];
    this.isSubmitted = false;

    // Clear the document upload component
    if (this.documentUpload) {
      this.documentUpload.clear();
    }
  }

  private markFormGroupTouched(): void {
    Object.keys(this.userForm.controls).forEach(key => {
      const control = this.userForm.get(key);
      control?.markAsTouched();
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.userForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched || this.isSubmitted));
  }

  getFieldError(fieldName: string): string {
    const field = this.userForm.get(fieldName);
    if (field?.errors) {
      if (field.errors['required']) {
        const fieldLabel = fieldName === 'directorate' ? 'Professional Directorate' :
          // fieldName === 'startDate' ? 'Start Date' :
          fieldName === 'lastDate' ? 'Last Submission Date' :
            fieldName === 'remarks' ? 'Remarks' :
              fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
        return `${fieldLabel} is required`;
      }
      if (field.errors['maxlength']) {
        return `Description cannot exceed ${field.errors['maxlength'].requiredLength} characters`;
      }
      // if (field.errors['minlength']) {
      //   return `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} must be at least ${field.errors['minlength'].requiredLength} characters`;
      // }
    }
    return '';
  }

  // Date validation
  // onStartDateChange(event: any): void {
  //   const startDate = event.target.value;
  //   const lastDateControl = this.userForm.get('lastDate');

  //   if (lastDateControl?.value && startDate > lastDateControl.value) {
  //     lastDateControl.setValue('');
  //   }
  // }

  onLastDateChange(event: any): void {
    const lastDate = event.target.value;
    const startDate = this.userForm.get('startDate')?.value;

    if (startDate && lastDate < startDate) {
      this.userForm.get('lastDate')?.setErrors({ 'invalidDate': true });
    }
  }

  // Helper methods for user data retrieval
  getSelectedUser(): User | undefined {
    const selectedUserId = this.userForm.get('selectedUser')?.value;
    return this.users.find(u => u.id == selectedUserId);
  }

  getSelectedUserName(): string {
    return this.getSelectedUser()?.name || '';
  }

  getSelectedUserEmail(): string {
    return this.getSelectedUser()?.email || '';
  }

  getSelectedUserDepartment(): string {
    return this.getSelectedUser()?.department || '';
  }

  getSelectedUserInitial(): string {
    const name = this.getSelectedUserName();
    return name ? name.charAt(0).toUpperCase() : '';
  }



  proposals: any[] = [];
  filteredProposals: any[] = [];
  proposalDataList: any[] = [];
  filteredProposalDataList: any[] = [];
  searchText: string = '';
  currentRole: string = 'doi';
  selectAll: boolean = false;

  // Proposal edit modal properties
  editProposalModal: boolean = false;
  selectedProposalForEdit: any = null;
  proposalEditForm: FormGroup;

  // Add Directorate modal properties
  addDirectorateModal: boolean = false;
  directorateForm: FormGroup;
  isAddingDirectorate: boolean = false;

  // Received Proposals modal properties
  receivedProposalsModal: boolean = false;
  receivedProposalsList: any[] = [];
  isLoadingReceivedProposals: boolean = false;
  receivedProposalsError: string = '';
  selectedSeekProposal: any = null;

  // Document Viewer modal properties
  documentViewerModal: boolean = false;
  uploadedDocumentsList: any[] = [];
  isLoadingDocuments: boolean = false;
  documentViewerError: string = '';
  selectedProposalForDocs: any = null;

  // File Download modal properties
  fileDownloadModal: boolean = false;
  uploadedFilesList: any[] = [];
  selectedProposalForFiles: any = null;

  stats = { total: 0, pending: 0, screening: 0, approved: 0 };

  filters = { category: '', status: '', priority: '', valuation: '' };

  // Modal control
  detailsModalOpen = false;
  selectedProposal: any;
  // userID: string;
  // challengeForm: FormGroup;
  // categoryOptions = [
  //   { label: 'To Move', value: 'To Move' },
  //   { label: 'To Fight', value: 'To Fight' },
  //   { label: 'To Float', value: 'To Float' },
  // ];
  priorityOptions = [
    { label: 'High', value: 'High' },
    { label: 'Medium', value: 'Medium' },
    { label: 'Low', value: 'Low' },
  ];
  statusOptions = [
    { label: 'Launch', value: 'Launch' },
    { label: 'Duplicate', value: 'Duplicate' },
    { label: 'Reject', value: 'Reject' },
  ]
  routeForm: FormGroup;
  roleList: any;
  userList: any;
  userListCopy: any[];
  // unitList: any;
  unitList: any[];
  selectedChallenges: any[];
  isEditMode = false;
  currentAction: 'view' | 'edit' = 'view';
  IRAremarks: string;
  fullscreenVisible = false;
  fullscreenChart: any = { type: '', data: {} };

  chartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'top' }
    }
  };

  stackedBarOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { position: 'top' } },
    scales: {
      x: { stacked: true },
      y: { stacked: true, beginAtZero: true, ticks: { precision: 0 } }
    }
  };

  stageProgressChart: any = {
    labels: ['AIP', 'Feasibility Study', 'AoN', 'EOI / PSO', 'Prototype Development', 'SSCT', 'RFP / CNC'],
    datasets: [
      { label: 'Pending', backgroundColor: '#FBBF24', data: [0, 0, 0, 0, 0, 0, 0] },
      { label: 'In Progress', backgroundColor: '#38BDF8', data: [0, 0, 0, 0, 0, 0, 0] },
      { label: 'Completed', backgroundColor: '#22C55E', data: [0, 0, 0, 0, 0, 0, 0] }
    ]
  };

  seekResponseSummaryDoughnutChart: any = {
    labels: ['Proposal Submitted', 'Nil Return Submitted', 'No Response Received'],
    datasets: [{ data: [0, 0, 0], backgroundColor: ['#22C55E', '#F59E0B', '#94A3B8'], hoverOffset: 4 }]
  };

  seekDoughnutOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom', labels: { padding: 12, usePointStyle: true } }
    },
    cutout: '65%'
  };

  /** Raw cycle data from API (each item = one seek cycle). */
  seekAnalyticsRawCycles: any[] = [];
  /** Top-level summary from make1/seek/summary API (for doughnut totals when available). */
  seekSummaryFromApi: {
    seek_cycles: number;
    total_directorates_involved: number;
    total_proposals_generated: number;
    overall_directorate_response_rate: number;
    proposal_submitted_total?: number;
    nil_return_submitted_total?: number;
    no_response_received_total?: number;
  } | null = null;
  seekAnalyticsMaxChartLabels = 12;

  seekDirectorateResponseChart: any = {
    labels: [] as string[],
    datasets: [
      { label: 'Proposal Submitted', backgroundColor: '#16a34a', borderColor: '#15803d', borderWidth: 1, data: [] as number[], stack: 'stack0' },
      { label: 'Nil Return Submitted', backgroundColor: '#ea580c', borderColor: '#c2410c', borderWidth: 1, data: [] as number[], stack: 'stack0' },
      { label: 'No Response Received', backgroundColor: '#64748b', borderColor: '#475569', borderWidth: 1, data: [] as number[], stack: 'stack0' }
    ]
  };
  seekStackedBarOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: { top: 12, right: 16, bottom: 8, left: 8 }
    },
    plugins: {
      legend: {
        position: 'top',
        align: 'end',
        labels: {
          usePointStyle: true,
          padding: 16,
          font: { size: 12, weight: '500' },
          color: '#334155'
        }
      },
      tooltip: {
        backgroundColor: 'rgba(15, 23, 42, 0.95)',
        padding: 12,
        titleFont: { size: 13, weight: '600' },
        bodyFont: { size: 12 },
        callbacks: {
          afterLabel: (ctx: any) => {
            const label = ctx.chart?.data?.labels?.[ctx.dataIndex];
            return label ? `Cycle: ${label}` : '';
          },
          label: (ctx: any) => {
            const chart = ctx.chart;
            const stackTotal = chart?.data?.datasets?.reduce(
              (sum: number, ds: any) => sum + (Number(ds.data?.[ctx.dataIndex]) || 0),
              0
            ) ?? 0;
            const pct = stackTotal > 0 ? Math.round((100 * ctx.raw) / stackTotal) : 0;
            return ` ${ctx.raw} (${pct}%)`;
          }
        }
      }
    },
    scales: {
      x: {
        stacked: true,
        grid: { display: false },
        ticks: {
          maxRotation: 45,
          maxTicksLimit: 12,
          font: { size: 11 },
          color: '#64748b',
          padding: 8
        },
        border: { display: false }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        min: 0,
        suggestedMax: 10,
        title: {
          display: true,
          text: 'Count',
          font: { size: 11, weight: '500' },
          color: '#64748b'
        },
        ticks: {
          precision: 0,
          stepSize: 1,
          font: { size: 11 },
          color: '#64748b',
          padding: 8
        },
        grid: { color: 'rgba(100, 116, 139, 0.15)' },
        border: { display: false }
      }
    },
    barPercentage: 0.7,
    categoryPercentage: 0.8
  };

  openFullscreen(chartKey: string): void {
    const map: any = {
      stageProgress: { type: 'bar', data: this.stageProgressChart, title: 'Proposal Progress Across Major TDF Stages' }
    };
    this.fullscreenChart = map[chartKey] || this.fullscreenChart;
    this.fullscreenVisible = true;
  }

  get canViewSeekProposalDataTable(): boolean {
    if (this.seekProposalTableAllowedRoleIds.length === 0) return false;
    const roleId = sessionStorage.getItem('user_role_id');
    if (roleId == null || roleId === '') return false;
    return this.seekProposalTableAllowedRoleIds.includes(Number(roleId));
  }

  // get seekAnalyticsKpis(): { seekCycles: number; totalDirectorates: number; totalProposals: number; responseRate: number; totalResponses: number } {
  //   const list = this.getFilteredSeekCycles();
  //   let totalDirectorates = 0;
  //   let totalProposals = 0;
  //   let proposalSub = 0;
  //   let nilReturn = 0;
  //   let noResponse = 0;
  //   list.forEach((c: any) => {
  //     totalDirectorates += c.directorate_count || 0;
  //     totalProposals += (c.proposal_submitted_count || 0) + (c.nil_return_count || 0);
  //     proposalSub += c.proposal_submitted_count || 0;
  //     nilReturn += c.nil_return_count || 0;
  //     noResponse += c.no_response_count || 0;
  //   });
  //   const totalResponses = proposalSub + nilReturn + noResponse;
  //   const rate = totalDirectorates > 0 ? Math.round((totalResponses / totalDirectorates) * 100) : 0;
  //   return {
  //     seekCycles: list.length,
  //     totalDirectorates,
  //     totalProposals,
  //     responseRate: rate,
  //     totalResponses
  //   };
  // }

  get seekAnalyticsKpis(): {
  seekCycles: number; totalDirectorates: number; totalProposals: number;
  responseRate: number; totalResponses: number;
} {
  const api = this.seekSummaryFromApi;
  if (api) {
    // ✅ Use top-level API values directly for KPI cards
    const totalResponses = (api.proposal_submitted_total ?? 0)
      + (api.nil_return_submitted_total ?? 0)
      + (api.no_response_received_total ?? 0);
    return {
      seekCycles:       Number(api.seek_cycles),
      totalDirectorates: Number(api.total_directorates_involved),
      totalProposals:   Number(api.total_proposals_generated),
      responseRate:     Number(api.overall_directorate_response_rate),
      totalResponses
    };
  }
  // fallback if API not loaded yet
  return { seekCycles: 0, totalDirectorates: 0, totalProposals: 0, responseRate: 0, totalResponses: 0 };
}

  getFilteredSeekCycles(): any[] {
    let list = [...this.seekAnalyticsRawCycles];
    const from = this.seekAnalyticsFromDate ? new Date(this.seekAnalyticsFromDate) : null;
    const to = this.seekAnalyticsToDate ? new Date(this.seekAnalyticsToDate) : null;
    if (from) {
      from.setHours(0, 0, 0, 0);
      list = list.filter((c: any) => c.endDate && new Date(c.endDate).getTime() >= from.getTime());
    }
    if (to) {
      to.setHours(23, 59, 59, 999);
      list = list.filter((c: any) => c.endDate && new Date(c.endDate).getTime() <= to.getTime());
    }
    if (this.seekAnalyticsYear != null) {
      list = list.filter((c: any) => c.endDate && new Date(c.endDate).getFullYear() === this.seekAnalyticsYear);
    }
    return list;
  }

  /** Build raw seek cycles from proposal list and init year options; then build charts. */
  loadSeekProposalAnalytics() {
    const list = this.proposalDataList || [];
    const rawCycles: any[] = [];
    const currentYear = new Date().getFullYear();
    const yearSet = new Set<number>();

    list.forEach((item: any, index: number) => {
      const endDate = item.end_date ? new Date(item.end_date) : null;
      if (endDate && !isNaN(endDate.getTime())) {
        yearSet.add(endDate.getFullYear());
      }
      const totalDirectorates = item.directorate?.length || 0;
      const proposalSub = item.proposal_submitted_count ?? 0;
      const nilRet = item.nil_return_count ?? 0;
      const noResp = Math.max(0, totalDirectorates - proposalSub - nilRet);

      rawCycles.push({
        endDate: endDate || null,
        seekDateLabel: endDate ? endDate.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' }) : `Cycle ${index + 1}`,
        totalDirectorates,
        proposalSubmitted: proposalSub,
        nilReturn: nilRet,
        noResponse: noResp
      });
    });

    this.seekAnalyticsRawCycles = rawCycles;
    this.seekAnalyticsYearOptions = Array.from({ length: 6 }, (_, i) => ({
      label: String(currentYear - i),
      value: currentYear - i
    }));
    // Keep from/to null for all-time display; do not auto-populate
    this.buildSeekAnalyticsCharts();
  }

  /** Build doughnut and bar charts from filtered cycles. */
  buildSeekAnalyticsCharts() {
    const cycles = this.getFilteredSeekCycles();
    const maxLabels = this.seekAnalyticsMaxChartLabels;
    const take = cycles.length <= maxLabels ? cycles : cycles.slice(-maxLabels);
    const labels = take.map((c: any) => c.seekDateLabel);
    const proposalSubmitted = take.map((c: any) => c.proposalSubmitted ?? 0);
    const nilReturn = take.map((c: any) => c.nilReturn ?? 0);
    const noResponse = take.map((c: any) => c.noResponse ?? 0);

    this.seekDirectorateResponseChart = {
      labels: labels.length ? labels : ['No data'],
      datasets: [
        { ...this.seekDirectorateResponseChart.datasets[0], data: labels.length ? proposalSubmitted : [0] },
        { ...this.seekDirectorateResponseChart.datasets[1], data: labels.length ? nilReturn : [0] },
        { ...this.seekDirectorateResponseChart.datasets[2], data: labels.length ? noResponse : [0] }
      ]
    };

    const api = this.seekSummaryFromApi;
    let totalSub: number;
    let totalNil: number;
    let totalNo: number;
    if (api && typeof api.proposal_submitted_total === 'number' && typeof api.nil_return_submitted_total === 'number' && typeof api.no_response_received_total === 'number') {
      totalSub = api.proposal_submitted_total;
      totalNil = api.nil_return_submitted_total;
      totalNo = api.no_response_received_total;
    } else {
      totalSub = cycles.reduce((s: number, c: any) => s + (c.proposalSubmitted ?? 0), 0);
      totalNil = cycles.reduce((s: number, c: any) => s + (c.nilReturn ?? 0), 0);
      totalNo = cycles.reduce((s: number, c: any) => s + (c.noResponse ?? 0), 0);
    }
    const total = totalSub + totalNil + totalNo;
    const doughnutData = total > 0 ? [totalSub, totalNil, totalNo] : [1, 1, 1];
    this.seekResponseSummaryDoughnutChart = {
      ...this.seekResponseSummaryDoughnutChart,
      datasets: [{
        data: doughnutData,
        backgroundColor: ['#22C55E', '#F59E0B', '#94A3B8'],
        hoverOffset: 4
      }]
    };
  }

  onSeekAnalyticsFilterChange(): void {
    this.loadSeekSummary();
  }

  // Chart Data
  chartData1 = {
    labels: ['2022', '2023', '2024'],
    datasets: [
      { label: 'Proposals Received', data: [120, 150, 180], backgroundColor: '#42A5F5' },
      { label: 'Completed', data: [90, 130, 160], backgroundColor: '#66BB6A' }
    ]
  };

  chartData2 = {
    labels: ['Idex', 'Adiiti', 'Prime', 'OC', 'Fauji'],
    datasets: [
      { label: 'Received', data: [50, 30, 40, 20, 25], backgroundColor: '#FFA726' },
      { label: 'In Progress', data: [20, 15, 10, 12, 8], backgroundColor: '#42A5F5' },
      { label: 'Completed', data: [25, 12, 20, 5, 15], backgroundColor: '#66BB6A' }
    ]
  };

  chartData3 = {
    labels: ['2022', '2023', '2024'],
    datasets: [
      { label: 'Funds Utilised (Cr)', data: [120, 180, 240], borderColor: '#42A5F5', fill: false, tension: 0.4 }
    ]
  };

  chartData4 = {
    labels: ['Proposal A', 'Proposal B', 'Proposal C', 'Proposal D'],
    datasets: [
      { data: [300, 150, 100, 80], backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726', '#AB47BC'] }
    ]
  };

  chartData5 = {
    labels: ['AI/ML', 'Defence Tech', 'Space', 'Robotics'],
    datasets: [
      { data: [100, 150, 120, 80], backgroundColor: ['#42A5F5', '#FF7043', '#66BB6A', '#AB47BC'] }
    ]
  };

  chartData6 = {
    labels: ['Idex', 'Adiiti', 'Prime', 'OC', 'Fauji'],
    datasets: [
      { label: 'Proposal Value', data: [200, 150, 180, 100, 120], backgroundColor: '#42A5F5' },
      { label: 'Disbursed Funds', data: [150, 120, 160, 90, 100], backgroundColor: '#66BB6A' }
    ]
  };
  schemeID: any;
  seekProposalTableAllowedRoleIds: number[] = [20, 6, 9];
  /** Default date range for make1/seek/summary: start_date=2025-01-01, end_date=2025-07-30 */
  seekAnalyticsFromDate: Date | null = null;
  seekAnalyticsToDate: Date | null = null;
  seekAnalyticsYear: number | null = null;
  seekAnalyticsYearOptions: { label: string; value: number | null }[] = [];
  
  // New Dashboard Features Data (for reusable components)
  totalContracts: number = 0;
  totalProposals: number = 0;
  totalSubSchemes: number = 0;
  totalPreLaunch: number = 0;
  totalForLaunch: number = 0;
  totalPostLaunch: number = 0;
  completedProposals: number = 0;
  subSchemes: any[] = [];
  schemeWiseApproved: any = {};
  schemeWiseSpent: any = {};
  schemeWisePending: any = {};
  schemeWiseGrant: any = {};
  schemeWiseProposal: any = {};
  schemeWisePrelaunch: any = {};
  schemeWiseForlaunch: any = {};
  schemeWisePostlaunch: any = {};
  schemeWiseCompleted: any = {};
  schemeWiseShortClosed: any = {};
  totalGrantsApproved: number = 0;
  totalGrantsSpent: number = 0;
  totalGrantsPending: number = 0;
  milestoneData: any[] = [];
  selectedProjectFilter: string = 'all';
  dashboardLoading: boolean = false;

  ngOnInit(): void {
    this.applyStageTrackingFilter();
    this.applySeekProposalFilter();
    this.switchRole('doi');
    const currentYear = new Date().getFullYear();
    this.yearOptions = Array.from({ length: 6 }, (_, i) => ({
      label: (currentYear - i).toString(),
      value: currentYear - i,
    }));
    this.gettableData();
    this.getUserList();
    this.getUnit();
    this.loadSeekSummary();
    this.proposalForm = this.fb.group({
      technologyInsertion: ['', Validators.required],
      justificationText: ['', Validators.required],
      exportPotential: ['', Validators.required],
      objective: ['', Validators.required],
      existingSystem: [''],
      functionalRequirements: [''],
      contemporarySolutions: [''],
      miscellaneousInfo: [''],
      references: [''],
      keywords: [''],
      estimatedRequirement: [''],
      testingMethodology: [''],
      civilSpinOffs: [''],
      technologyReadinessLevel: [''],
      proposalExplanation: [''],
      qaAgency: [''],
      apsoConcurrence: [''],
      psqr: [''],
      additionalInformation: [''],
      qtyRequired: [''],


    });
    this.route.queryParams.subscribe(params => {
      const schemeId = params['scheme_id'];
      this.schemeID = schemeId != null && schemeId !== '' ? schemeId : 16;
      this.getDashboardData(this.selectedYear);
      this.getProposal('work_on');
      this.loadNewDashboardData();
      this.loadSeekSummary();
      this.getProposalData();
    });

   

    // Initialize proposal edit form
    this.proposalEditForm = this.fb.group({
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
      remark: ['', [Validators.required, Validators.maxLength(500)]],
      directorate: [[], Validators.required],
      status: [1, Validators.required]
    });

    // Initialize directorate form
    this.directorateForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      code: ['', [Validators.required, Validators.minLength(2)]],
      description: ['']
    });
    this.loginName = sessionStorage.getItem('login_name');
  }
   getProposal(tab: 'work_done' | 'work_on',page=1) {
    this.proposalData=[]
    // this.lazy=true;
    let url = `/master/work-details/proposal/?scheme_id=${this.schemeID}&tab=${tab}`;
    // let url=`/master/proposals/?scheme=${this.schemeID}&page=${page}`;
    // if(tab){
    //   url+=`&proposal_status=${tab.status}`;
    // }
    const sub = this.api.getAPI(url ).subscribe((res: any) => {
        this.proposalData = res.data;
        console.log('>>>>>proposalData status',this.proposalData);
        this.totalCount = res.count;
      });
    this.subscriptions.add(sub);
  }

  applyStageTrackingFilter(): void {
    const f = this.stageTrackingFilters;
    const list = this.stageTrackingProposalData || [];
    this.filteredStageTrackingData = list.filter((p: any) => {
      const currentStage = (p.current_stage || p.step_summary?.current_step_name || '').toString().toLowerCase();
      const overallStatus = (this.getOverallStatus(p) || '').toString().toLowerCase();
      const days = (this.getDaysInCurrentStage(p) ?? '').toString().toLowerCase();
      const updatedAt = (p.updated_at ? new Date(p.updated_at).toLocaleDateString('en-GB') : '').toLowerCase();
      if (f.name && !(p.name ?? '').toString().toLowerCase().includes(f.name.trim().toLowerCase())) return false;
      if (f.current_stage && !currentStage.includes(f.current_stage.trim().toLowerCase())) return false;
      if (f.overall_status && !overallStatus.includes(f.overall_status.trim().toLowerCase())) return false;
      if (f.updated_at && !updatedAt.includes(f.updated_at.trim().toLowerCase())) return false;
      if (f.days && !days.includes(f.days.trim().toLowerCase())) return false;
      return true;
    });
    this.stageTableCurrentPage = 1;
    this.setupStageTrackingPagination();
  }

  sortStageTracking(field: string): void {
    if (this.stageTrackingSortField === field) {
      this.stageTrackingSortOrder = (this.stageTrackingSortOrder === 1 ? -1 : 1) as 1 | -1;
    } else {
      this.stageTrackingSortField = field;
      this.stageTrackingSortOrder = 1;
    }
    this.setupStageTrackingPagination();
  }

  setupStageTrackingPagination(): void {
    let data = [...(this.filteredStageTrackingData || [])];
    if (this.stageTrackingSortField) {
      const order = this.stageTrackingSortOrder;
      const field = this.stageTrackingSortField;
      data.sort((a: any, b: any) => {
        let va: any, vb: any;
        if (field === 'name') { va = (a.name ?? '').toString(); vb = (b.name ?? '').toString(); }
        else if (field === 'current_stage') { va = (this.getCurrentStage(a) ?? '').toString(); vb = (this.getCurrentStage(b) ?? '').toString(); }
        else if (field === 'overall_status') { va = (this.getOverallStatus(a) ?? '').toString(); vb = (this.getOverallStatus(b) ?? '').toString(); }
        else if (field === 'updated_at') {
          va = a.updated_at ? new Date(a.updated_at).getTime() : 0;
          vb = b.updated_at ? new Date(b.updated_at).getTime() : 0;
          return order * (va - vb);
        }
        else if (field === 'days') {
          va = this.getDaysInCurrentStage(a) ?? 0;
          vb = this.getDaysInCurrentStage(b) ?? 0;
          return order * (Number(va) - Number(vb));
        }
        else { return 0; }
        const cmp = (va || '').localeCompare(vb || '', undefined, { sensitivity: 'base' });
        return order * cmp;
      });
    }
    const total = data.length;
    this.stageTableTotalPages = Math.max(1, Math.ceil(total / this.stageTablePageSize));
    const start = (this.stageTableCurrentPage - 1) * this.stageTablePageSize;
    const end = start + this.stageTablePageSize;
    this.stageTablePaginatedData = data.slice(start, end);
    this.stageTableStartEntry = total ? start + 1 : 0;
    this.stageTableEndEntry = Math.min(end, total);
  }

  get stageTablePages(): number[] {
    return Array.from({ length: this.stageTableTotalPages }, (_, i) => i + 1);
  }

  changeStageTrackingPage(page: number): void {
    if (page < 1 || page > this.stageTableTotalPages) return;
    this.stageTableCurrentPage = page;
    this.setupStageTrackingPagination();
  }

  changeStageTrackingPageSize(): void {
    this.stageTableCurrentPage = 1;
    this.setupStageTrackingPagination();
  }

  applySeekProposalFilter(): void {
    const f = this.seekTableFilters;
    const list = this.proposalDataList || [];
    this.filteredProposalDataList = list.filter((p: any) => {
      const endDateStr = p.end_date ? new Date(p.end_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '';
      const dateExt = this.isDateExtended(p) ? 'yes' : 'no';
      const remarkStr = (p.remark ?? '').toString().toLowerCase();
      const dirStr = this.getDirectorateDisplayText(p.directorate).toLowerCase();
      if (f.end_date && !endDateStr.toLowerCase().includes(f.end_date.trim().toLowerCase())) return false;
      if (f.date_extended && !dateExt.includes(f.date_extended.trim().toLowerCase())) return false;
      if (f.remark && !remarkStr.includes(f.remark.trim().toLowerCase())) return false;
      if (f.directorate && !dirStr.includes(f.directorate.trim().toLowerCase())) return false;
      return true;
    });
    this.seekTableCurrentPage = 1;
    this.setupSeekProposalPagination();
  }

  sortSeekProposal(field: string): void {
    if (this.seekTableSortField === field) {
      this.seekTableSortOrder = (this.seekTableSortOrder === 1 ? -1 : 1) as 1 | -1;
    } else {
      this.seekTableSortField = field;
      this.seekTableSortOrder = 1;
    }
    this.setupSeekProposalPagination();
  }

  setupSeekProposalPagination(): void {
    let data = [...(this.filteredProposalDataList || [])];
    if (this.seekTableSortField) {
      const order = this.seekTableSortOrder;
      const field = this.seekTableSortField;
      data.sort((a: any, b: any) => {
        let va: any, vb: any;
        if (field === 'end_date') {
          va = a.end_date ? new Date(a.end_date).getTime() : 0;
          vb = b.end_date ? new Date(b.end_date).getTime() : 0;
          return order * (va - vb);
        }
        if (field === 'remark') { va = (a.remark ?? '').toString(); vb = (b.remark ?? '').toString(); }
        else if (field === 'directorate') {
          va = this.getDirectorateDisplayText(a.directorate);
          vb = this.getDirectorateDisplayText(b.directorate);
        }
        else { return 0; }
        const cmp = (va || '').localeCompare(vb || '', undefined, { sensitivity: 'base' });
        return order * cmp;
      });
    }
    const total = data.length;
    this.seekTableTotalPages = Math.max(1, Math.ceil(total / this.seekTablePageSize));
    const start = (this.seekTableCurrentPage - 1) * this.seekTablePageSize;
    const end = start + this.seekTablePageSize;
    this.seekTablePaginatedData = data.slice(start, end);
    this.seekTableStartEntry = total ? start + 1 : 0;
    this.seekTableEndEntry = Math.min(end, total);
  }

  get seekTablePages(): number[] {
    return Array.from({ length: this.seekTableTotalPages }, (_, i) => i + 1);
  }

  changeSeekProposalPage(page: number): void {
    if (page < 1 || page > this.seekTableTotalPages) return;
    this.seekTableCurrentPage = page;
    this.setupSeekProposalPagination();
  }

  changeSeekProposalPageSize(): void {
    this.seekTableCurrentPage = 1;
    this.setupSeekProposalPagination();
  }

  getCurrentStage(proposal: any): string {
    return proposal.current_stage || proposal.step_summary?.current_step_name || proposal.proposal_status || 'Not Available';
  }

  getOverallStatus(proposal: any): string {
    const status = proposal.overall_status || proposal.proposal_status || proposal.status || 'Not Started';
    return this.toTitleCase((status || '').toString().replace(/_/g, ' '));
  }

  getStageStatus(proposal: any, stageKey: string): string {
    const stageMap = proposal.stage_status || proposal.stageStatus || {};
    const raw = stageMap[stageKey] || stageMap[stageKey.toLowerCase()] || '';
    const normalized = (raw || '').toString().toLowerCase();
    if (!normalized) return 'Not Started';
    if (normalized.includes('complete')) return 'Completed';
    if (normalized.includes('progress') || normalized.includes('ongoing')) return 'In Progress';
    if (normalized.includes('pending')) return 'Pending';
    return this.toTitleCase(normalized);
  }

  /** Map status text to stage-dot CSS class for legend-aligned dots */
  getStageDotClass(status: string): string {
    const n = (status || '').toLowerCase();
    if (n === 'completed') return 'stage-dot stage-dot-completed';
    if (n === 'in progress' || n === 'on-going' || n === 'ongoing' || n === 'in review' || n === 'initiated') return 'stage-dot stage-dot-progress';
    if (n === 'pending' || n === 'not started') return 'stage-dot stage-dot-pending';
    return 'stage-dot stage-dot-pending';
  }

  getStageTagSeverity(status: string): 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' {
    const n = (status || '').toLowerCase();
    if (n === 'completed') return 'success';
    if (n === 'in progress' || n === 'on-going' || n === 'ongoing') return 'info';
    if (n === 'pending') return 'warning';
    if (n === 'rejected' || n.includes('closed')) return 'danger';
    return 'secondary';
  }

  getDaysInCurrentStage(proposal: any): number | string {
    const lastUpdated = proposal.stage_updated_at || proposal.updated_at || proposal.modified_at;
    if (!lastUpdated) return '-';
    const d = new Date(lastUpdated);
    if (isNaN(d.getTime())) return '-';
    const days = Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
    return days >= 0 ? days : '-';
  }

  private toTitleCase(value: string): string {
    return (value || '').replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.slice(1).toLowerCase());
  }

  navigateToSchemeTransaction(schemeName: any, phaseId: any) {
    // this.router.navigate(['/tdf-transaction'], {
    //     queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId , step:schemeName.step_summary.current_step_id }
    //   });
  }

  onPageChange(event){
    const rows=event.rows;
    const first=event.first;
    const page=first/rows+1;
    if (this.activeTabIndex === 0) {
      this.getProposal('work_on', page);
    } else if (this.activeTabIndex === 1) {
      this.getProposal('work_done', page);
    }
    // this.getProposal(this.activeStatusTabIndex,page);
  }
   /**
   * Handle tab change between Work Done and Pending Work
   */
  onTabChange(e: any) {
    this.activeTabIndex = e.index;

    if (e.index === 0) {
      this.getProposal('work_on', 1);
    } else if (e.index === 1) {
      this.getProposal('work_done', 1);
    }
  }
  // Handle proposal status tab change
  onProposalStatusTabChange(tab: any) {
    const tabIndex = tab.tab;
    this.activeStatusTabIndex = tab;

    if (tabIndex === 0) {
      // this.initializeNewProposalForm();
      // this.getDraftProposals()
    } else {
      // For other tabs, filter proposals by status
      this.getProposal(tab, 1)
      // this.filterProposalsByStatus();
    }
    // Note: PrimeNG pagination will automatically reset to first page when data changes
  }
  searchQuery: string = '';
  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'approved':
        return 'bg-success';
      case 'pending':
        return 'bg-warning text-dark';
      case 'short_closed':
        return 'bg-secondary';
      case 'rejected':
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }
  getFieldValue(obj: any, fieldPath: string): any {
    if (!obj || !fieldPath) {
      return null;
    }
    try {
      return fieldPath.split('.').reduce((acc, part) => {
        if (acc && typeof acc === 'object' && part in acc) {
          return acc[part];
        }
        return undefined;
      }, obj);
    } catch {
      return undefined;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.currentAction == 'edit') {
        this.proposalForm?.enable();
      } else {
        this.proposalForm?.disable();
      }
      //  this.rebuildEditor();
    }, 3000);
  }
  editorReady = true;
  rebuildEditor() {
    this.editorReady = false;
    setTimeout(() => {
      this.init = this.getTinyInit(); // reapply config
      this.editorReady = true; // rebuild editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      plugins:
        'advlist anchor fullscreen insertdatetime autolink link lists image code advcode mergetags wordcount ai a11ychecker advcode advtemplate advlist advtable anchor autocorrect autosave editimage image link linkchecker lists markdown media mediaembed pageembed powerpaste searchreplace table template tinymcespellchecker typography visualblocks wordcount',
      toolbar:
        'undo redo fullscreen | styles fontsizeinput lineheight |insertdatetime  bold italic strikethrough backcolor forecolor visualblocks | align bullist numlist outdent indent | advlist  table link image media pageembed | spellcheckdialog a11ycheck code | searchreplace',
      readonly: this.currentAction === 'view',
    };
  }
  switchRole(role: string) {
    this.currentRole = role;
    this.applyFilters();
  }

  applyFilters() {
    let filtered = [...this.proposals];

    // Step 1: Category filter (from dropdown)
    if (this.filters.category) {
      filtered = filtered.filter((p) => p.category === this.filters.category);
    }

    // Step 2: Role filter (restrict based on role)
    // if (this.currentRole === 'doi') {
    //   filtered = filtered.filter(p => ['To Move', 'To Float'].includes(p.category));
    // } else if (this.currentRole === 'tdac') {
    //   filtered = filtered.filter(p => p.category === 'To Fight');
    // }

    // Step 3: Priority filter
    if (this.filters.priority) {
      filtered = filtered.filter((p) => p.priority === this.filters.priority);
    }
    if (this.filters.valuation) {
      filtered = filtered.filter((p) => p.valuation === this.filters.valuation);
    }
    // Step 4: Status filter (if needed)
    if (this.filters.status) {
      // filtered = filtered.filter(p => p.status === this.filters.status);
    }

    this.filteredProposals = filtered;
    this.updateStats();
  }

  updateStats() {
    this.stats.total = this.filteredProposals.length;
    // this.stats.pending = this.filteredProposals.filter(p => p.status === 'pending').length;
    // this.stats.screening = this.filteredProposals.filter(p => p.status === 'screening').length;
    // this.stats.approved = this.filteredProposals.filter(p => p.status === 'approved').length;
  }

  updateCategory(id: any, category: string) {
    const p = this.proposals.find((x) => x.id == id);
    if (p) p.category = category;
    this.applyFilters(); // optional: refresh view/stats if you rely on filteredProposals
  }

  updatePriority(id: any, priority: string) {
    // const proposal = this.proposals.find(p => p.id === id);
    // if (proposal) proposal.priority = priority;
  }
  updateValuation(id: any, priority: string) {
    // const proposal = this.proposals.find(p => p.id === id);
    // if (proposal) proposal.priority = priority;
  }
  updatelaunchStatus(id: any, priority: string) { }
  selectedChallengeCount: any[] = [];
  toggleSelectAll() {
    // this.filteredProposals.forEach(p => (p.selected = this.selectAll));
    this.filteredProposals.forEach(proposal => {
      proposal.selected = this.selectAll;
    });

    if (this.selectAll) {
      this.selectedChallengeCount = [...this.filteredProposals];
    } else {
      this.selectedChallengeCount = [];
    }
  }

  bulkAction(action: string) {
    // const selected = this.filteredProposals.filter(p => p.selected);
    // if (!selected.length) {
    //   alert('Please select at least one proposal.');
    //   return;
    // }
    // alert(`${action.toUpperCase()} applied on: ${selected.map(p => p.id).join(', ')}`);
  }

  viewDetails(proposal: any, mode: 'view') {
    this.selectedProposal = proposal;
    this.detailsModalOpen = true;
    this.currentAction = mode;
    this.isEditMode = false;
    this.rebuildEditor();
    this.proposalForm.disable();
    this.proposalForm.patchValue({
      technologyInsertion: proposal?.title,
      justificationText: proposal?.major_description,
      exportPotential: proposal?.technology_area,
      objective: proposal?.objective,
      existingSystem: proposal?.description,
      functionalRequirements: proposal?.functional_requirement,
      contemporarySolutions: proposal?.contemporary_solution,
      miscellaneousInfo: proposal?.miscellaneous_information,
      references: proposal?.references,
      keywords: proposal?.keywords,
      estimatedRequirement: proposal?.estimated_requirement,
      testingMethodology: proposal?.testing_methodology,
      civilSpinOffs: proposal?.civil_spin,
      technologyReadinessLevel: proposal?.technology_readiness,
      proposalExplanation: proposal?.proposal_explain,
      qaAgency: proposal?.qa_agency,
      apsoConcurrence: proposal?.concurrence,
      psqr: proposal?.psqr,
      additionalInformation: proposal?.additional_information,
      qtyRequired: proposal?.quatity_required,
    });


  }
  savetableData(proposal: Proposal) {
    this.proposalForm.reset();
    this.selectedProposal = proposal;
    this.proposalForm.patchValue({
      organisation: proposal.organisation,
      category: proposal.category,
      priority: proposal.priority,
      releaseDate: proposal.release_date,
      approvedBy: proposal.approved_by,
      coordinatingAgency: proposal.coordinated_agency,
      technologyDomain: proposal.technology_domain,

      // valuation:proposal.valuation, // fields for DIO
      challenge_status: proposal.challenge_status,

      challengeTitle: proposal.title,
      nodalOfficer: proposal.nodal_officer,
      problemStatement: proposal.problem_statement,
      challengeBrief: proposal.challenge_brief,
      prototypeDevelopment: proposal.prototype_development,
      requirement: proposal.requirement,
      ipValue: proposal.ip_value,
      functionalAdvantages: proposal.functional_advantages,
      domestic: proposal.domestic,
      substitution: proposal.substitution,
      preliminaryScope: proposal.preliminary_scope,
      competitiveSolution: proposal.competitive_solution,
      potentialMarket: proposal.potential_market,
      riskAssessment: proposal.risk_assessment,
      mpoQty: proposal.mpo_qty,
    });
    this.onSubmit()
  }

  closeDetailsModal() {
    this.detailsModalOpen = false;
    this.selectedProposal = null;
  }

  editProposal(proposal: any, mode: 'edit') {
    this.currentAction = mode;
    this.rebuildEditor()
    this.isEditMode = true;
    this.proposalForm.enable();

    this.selectedProposal = { ...proposal };
    this.proposalForm.reset();
    console.log(proposal)
    this.proposalForm.patchValue({
      technologyInsertion: proposal?.title,
      justificationText: proposal?.major_description,
      exportPotential: proposal?.technology_area,
      objective: proposal?.objective,
      existingSystem: proposal?.description,
      functionalRequirements: proposal?.functional_requirement,
      contemporarySolutions: proposal?.contemporary_solution,
      miscellaneousInfo: proposal?.miscellaneous_information,
      references: proposal?.references,
      keywords: proposal?.keywords,
      estimatedRequirement: proposal?.estimated_requirement,
      testingMethodology: proposal?.testing_methodology,
      civilSpinOffs: proposal?.civil_spin,
      technologyReadinessLevel: proposal?.technology_readiness,
      proposalExplanation: proposal?.proposal_explain,
      qaAgency: proposal?.qa_agency,
      apsoConcurrence: proposal?.concurrence,
      psqr: proposal?.psqr,
      additionalInformation: proposal?.additional_information,
      qtyRequired: proposal?.quatity_required,
    });
    this.detailsModalOpen = true;
  }
  gettableData() {
    let unit = Number(sessionStorage.getItem('unit_id'));
    this.api
      .getAPI(`/make1/dashboard/need-generation/list/?role_id=${this.userID}`)
      .subscribe({
        next: (res: any[]) => {
          this.proposals = res;
          this.filteredProposals = [...this.proposals];
        },
      });
  }
  onSubmitData() {
    const formData = new FormData();
    // formData.append('proposal_step', this.id);
    formData.append('title', this.proposalForm.value.technologyInsertion);
    formData.append('major_description', this.proposalForm.value.justificationText);
    formData.append('technology_area', this.proposalForm.value.exportPotential);
    formData.append('objective', this.proposalForm.value.objective);
    formData.append('description', this.proposalForm.value.existingSystem);
    formData.append('functional_requirement', this.proposalForm.value.functionalRequirements);
    formData.append('contemporary_solution', this.proposalForm.value.contemporarySolutions);
    formData.append('miscellaneous_information', this.proposalForm.value.miscellaneousInfo);
    formData.append('references', this.proposalForm.value.references);
    formData.append('keywords', this.proposalForm.value.keywords);
    formData.append('estimated_requirement', this.proposalForm.value.estimatedRequirement);
    formData.append('testing_methodology', this.proposalForm.value.testingMethodology);
    formData.append('civil_spin', this.proposalForm.value.civilSpinOffs);
    formData.append('technology_readiness', this.proposalForm.value.technologyReadinessLevel);
    formData.append('proposal_explain', this.proposalForm.value.proposalExplanation);
    formData.append('qa_agency', this.proposalForm.value.qaAgency);
    formData.append('concurrence', this.proposalForm.value.apsoConcurrence);
    formData.append('psqr', this.proposalForm.value.psqr);
    formData.append('additional_information', this.proposalForm.value.additionalInformation);
    formData.append('quatity_required', this.proposalForm.value.qtyRequired);


    if (this.draftSotrFile) {
      formData.append('upload_photograph', this.draftSotrFile);
    }

    if (this.supportingDocsFiles) {
      // this.supportingDocsFiles.forEach(file => {
      formData.append('feasibility_study', this.supportingDocsFiles); // Change key name if needed
      // });
    }

    // if (this.needGenId) {
    let url = `/make1/need-generation/${this.selectedProposal.id}/`;
    //  if(this.screening == 'initiation'){
    //   url = `/tdf/need-generation/`
    // }else{
    //   url = `/tdf/approval/need-generation/`
    // }
    const sub = this.api
      .putAPI(url, formData)
      .subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Form submitted successfully',
        });
        this.fileUpload.clear();
        this.draftSotrUpload.clear();
        if (res.upload_photograph) {
          this.selectedProposal.upload_photograph = res.upload_photograph;
        }

        if (res.feasibility_study) {
          // this.selectedProposal.feasibility_study = res.feasibility_study.map((f: any) => ({
          //   file: f.file, // adapt based on backend key
          //   name: f.name ?? this.getFileName(f.file),
          // }));
          this.selectedProposal.feasibility_study = res.feasibility_study;
        }
        this.gettableData();
      });
    this.subscriptions.add(sub);
    // }
  }
  /** Load DOI Seek Proposals table from base_url/transaction/seek/proposal/?scheme_id=16 (or current scheme). */
  getProposalData() {
    const schemeId = this.schemeID ?? 16;
    const sub = this.api.getAPI(`/transaction/seek/proposal/?scheme_id=${schemeId}`).subscribe({
      next: (res: any) => {
        const raw = (res.status === 1 && res.data) ? res.data : (res.data ?? res.results ?? (Array.isArray(res) ? res : []));
        const list = Array.isArray(raw) ? raw : [];
        this.proposalDataList = list.map((proposal: any, index: number) => {
          const directorate = proposal.directorate ?? proposal.directorates ?? proposal.directorate_list ?? [];
          const dirList = Array.isArray(directorate) ? directorate : [];
          const dirNormalized = dirList.map((d: any) => (typeof d === 'object' && d !== null && 'name' in d) ? d : { id: d?.id, name: typeof d === 'string' ? d : d?.name ?? '-' });
          return {
            id: proposal.id ?? proposal.seek_id ?? index,
            end_date: proposal.end_date ?? proposal.last_submission_date ?? proposal.date ?? proposal.seek_date,
            remark: proposal.remark ?? proposal.remarks ?? '',
            directorate: dirNormalized,
            hasDocuments: !!(proposal.seek_file && Array.isArray(proposal.seek_file) && proposal.seek_file.length > 0) || !!proposal.has_documents,
            extended_date1: proposal.extended_date1 ?? proposal.extended_date_1 ?? null,
            extended_date2: proposal.extended_date2 ?? proposal.extended_date_2 ?? null,
            ...proposal
          };
        });
        this.applySeekProposalFilter();
        const allDirectorates = this.proposalDataList.flatMap((p: any) => (p.directorate || []).map((d: any) => d.name).filter(Boolean));
        this.unitNamesInProposals = [...new Set(allDirectorates)];
        this.loadSeekProposalAnalytics();
      },
      error: () => {
        this.proposalDataList = [];
        this.applySeekProposalFilter();
      }
    });
    this.subscriptions.add(sub);
  }

  /** Load Seek Proposal Response Analytics from make1/seek/summary API.
   * URL: base_url/make1/seek/summary/?scheme_id=16&start_date=YYYY-MM-DD&end_date=YYYY-MM-DD
   * Feeds: Seek Proposal Response Analytics KPIs, Overall Directorate Response Summary,
   * Directorate Response by Seek Cycle, DOI Seek Proposals: Directorate Responses & Last Submission Dates.
   */
  // loadSeekSummary() {
  //   const schemeId = this.schemeID ?? 16;
  //   let url = `/make1/seek/summary/?scheme_id=${schemeId}`;
  //   const fmt = (d: Date) => {
  //     const x = new Date(d);
  //     return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
  //   };
  //   if (this.seekAnalyticsFromDate && this.seekAnalyticsToDate) {
  //     url += `&start_date=${fmt(this.seekAnalyticsFromDate)}&end_date=${fmt(this.seekAnalyticsToDate)}`;
  //   } else if (this.seekAnalyticsYear != null) {
  //     url += `&year=${this.seekAnalyticsYear}`;
  //   }
  //   // else: no date params → all-time data (API returns all records when no filter)
  //   const sub = this.api.getAPI(url).subscribe({
  //     next: (res: any) => {
  //       const summary = res.overall_directorate_response_summary ?? res;
  //       const proposalSubTotal = summary.proposal_submitted ?? summary.total_proposal_submitted ?? res.proposal_submitted ?? res.total_proposal_submitted;
  //       const nilReturnTotal = summary.nil_return_submitted ?? summary.total_nil_return ?? res.nil_return_submitted ?? res.total_nil_return;
  //       const noResponseTotal = summary.no_response_received ?? summary.total_no_response ?? res.no_response_received ?? res.total_no_response;
  //       this.seekSummaryFromApi = {
  //         seek_cycles: Number(res.seek_cycles ?? 0),
  //         total_directorates_involved: Number(res.total_directorates_involved ?? 0),
  //         total_proposals_generated: Number(res.total_proposals_generated ?? 0),
  //         overall_directorate_response_rate: Number(res.overall_directorate_response_rate ?? 0),
  //         proposal_submitted_total: typeof proposalSubTotal === 'number' ? proposalSubTotal : undefined,
  //         nil_return_submitted_total: typeof nilReturnTotal === 'number' ? nilReturnTotal : undefined,
  //         no_response_received_total: typeof noResponseTotal === 'number' ? noResponseTotal : undefined
  //       };
  //       const graph = res.directorate_response_graph ?? [];
  //       const graphList = Array.isArray(graph) ? graph : [];
  //       const defaultTotalDirectorates = Number(res.total_directorates_involved ?? 0);
  //       const rawCycles = graphList.map((c: any, index: number) => {
  //         const dateRaw = c.seek_date ?? c.end_date ?? c.date;
  //         const endDate = dateRaw ? new Date(dateRaw) : null;
  //         const totalDirectorates = (c.total_directorates ?? c.total_directorates_involved ?? (c.directorate?.length ?? (c.directorates?.length ?? 0))) || defaultTotalDirectorates;
  //         const proposalSub = c.proposal_submitted_count ?? c.proposal_submitted ?? c.proposals_submitted ?? 0;
  //         const nilRet = c.nil_return_count ?? c.nil_return_submitted ?? c.nil_return ?? c.nil_returns ?? 0;
  //         const noResp = c.no_response_received ?? c.no_response_count ?? c.no_response_submitted ?? c.no_response ?? (typeof c.no_response_count === 'number' ? c.no_response_count : Math.max(0, totalDirectorates - proposalSub - nilRet));
  //         const seekDateLabel = c.label ?? (endDate && !isNaN(endDate.getTime()) ? endDate.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' }) : (c.seek_date || `Cycle ${index + 1}`));
  //         return {
  //           endDate: endDate && !isNaN(endDate.getTime()) ? endDate : null,
  //           seekDateLabel,
  //           totalDirectorates,
  //           proposalSubmitted: proposalSub,
  //           nilReturn: nilRet,
  //           noResponse: noResp
  //         };
  //       });
  //       this.seekAnalyticsRawCycles = rawCycles;
  //       this.buildSeekAnalyticsCharts();
  //       // DOI Seek Proposals table is loaded only from /transaction/seek/proposal/?scheme_id=16 (getProposalData); do not overwrite here.
  //     },
  //     error: () => {
  //       this.seekSummaryFromApi = null;
  //       this.seekAnalyticsRawCycles = [];
  //       this.buildSeekAnalyticsCharts();
  //       // proposalDataList stays from getProposalData() (transaction/seek/proposal)
  //     }
  //   });
  //   this.subscriptions.add(sub);
  // }

  loadSeekSummary() {
  const schemeId = this.schemeID ?? 16;
  let url = `/make1/seek/summary/?scheme_id=${schemeId}`;
  const fmt = (d: Date) => {
    const x = new Date(d);
    return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`;
  };
  if (this.seekAnalyticsFromDate && this.seekAnalyticsToDate) {
    url += `&start_date=${fmt(this.seekAnalyticsFromDate)}&end_date=${fmt(this.seekAnalyticsToDate)}`;
  } else if (this.seekAnalyticsYear != null) {
    url += `&year=${this.seekAnalyticsYear}`;
  }

  const sub = this.api.getAPI(url).subscribe({
    next: (res: any) => {

      // ✅ FIX 1: KPI cards — map directly from top-level API keys
      this.seekSummaryFromApi = {
        seek_cycles: Number(res.seek_cycles ?? 0),
        total_directorates_involved: Number(res.total_directorates_involved ?? 0),
        total_proposals_generated: Number(res.total_proposals_generated ?? 0),
        overall_directorate_response_rate: Number(res.overall_directorate_response_rate ?? 0),
        // ✅ FIX 2: sum proposal_submitted & nil_return_submitted from graph for doughnut totals
        proposal_submitted_total: undefined,
        nil_return_submitted_total: undefined,
        no_response_received_total: undefined
      };

      const graph = res.directorate_response_graph ?? [];
      const graphList = Array.isArray(graph) ? graph : [];
      const defaultTotalDirectorates = Number(res.total_directorates_involved ?? 0);

      const rawCycles = graphList.map((c: any, index: number) => {
        const dateRaw = c.seek_date ?? c.end_date ?? c.date;
        const endDate = dateRaw ? new Date(dateRaw) : null;

        // ✅ FIX 3: API uses `proposal_submitted` and `nil_return_submitted` (not *_count)
        const proposalSub = Number(
          c.proposal_submitted_count ?? c.proposal_submitted ?? 0
        );
        const nilRet = Number(
          c.nil_return_count ?? c.nil_return_submitted ?? c.nil_return ?? 0
        );
        const totalDirectorates = Number(
          c.total_directorates ?? c.total_directorates_involved ?? defaultTotalDirectorates
        );
        // ✅ FIX 4: no_response not in API — calculate it
        const noResp = Math.max(0, totalDirectorates - proposalSub - nilRet);

        const seekDateLabel = c.label ?? (
          endDate && !isNaN(endDate.getTime())
            ? endDate.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' })
            : (c.seek_date || `Cycle ${index + 1}`)
        );

        return {
          endDate: endDate && !isNaN(endDate.getTime()) ? endDate : null,
          seekDateLabel,
          totalDirectorates,
          proposalSubmitted: proposalSub,
          nilReturn: nilRet,
          noResponse: noResp
        };
      });

      // ✅ FIX 5: compute doughnut totals from graph since API has no top-level totals
      const totalSub = rawCycles.reduce((s: number, c: any) => s + c.proposalSubmitted, 0);
      const totalNil = rawCycles.reduce((s: number, c: any) => s + c.nilReturn, 0);
      const totalNo  = rawCycles.reduce((s: number, c: any) => s + c.noResponse, 0);
      this.seekSummaryFromApi.proposal_submitted_total  = totalSub;
      this.seekSummaryFromApi.nil_return_submitted_total = totalNil;
      this.seekSummaryFromApi.no_response_received_total = totalNo;

      this.seekAnalyticsRawCycles = rawCycles;
      this.buildSeekAnalyticsCharts();
    },
    error: () => {
      this.seekSummaryFromApi = null;
      this.seekAnalyticsRawCycles = [];
      this.buildSeekAnalyticsCharts();
    }
  });
  this.subscriptions.add(sub);
}

  unitNamesInProposals: string[] = [];



  viewProposal(proposal: any) {
    // Open a modal or navigate to view the proposal details
    console.log('Viewing proposal:', proposal);
    // You can implement a modal or navigation here
    this.messageService.add({
      severity: 'info',
      summary: 'View Proposal',
      detail: `Viewing proposal: ${proposal.code}`
    });
  }

  editProposalData(proposal: any) {
    this.selectedProposalForEdit = proposal;
    this.editProposalModal = true;

    // Populate the form with existing data
    this.proposalEditForm.patchValue({
      start_date: proposal.start_date,
      end_date: proposal.end_date,
      remark: proposal.remark,
      directorate: proposal.directorate?.map((d: any) => d.id),
      status: proposal.status
    });
  }

  deleteProposal(proposal: any) {
    // Show confirmation dialog before deleting
    if (confirm(`Are you sure you want to delete proposal: ${proposal.code}?`)) {
      const sub = this.api.deleteAPI(`/transaction/seek/proposal/${proposal.id}/`).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Proposal deleted successfully'
          });
          // Refresh the data
          this.loadSeekSummary();
        },
        error: (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to delete proposal'
          });
          console.error('Delete error:', err);
        }
      });
      this.subscriptions.add(sub);
    }
  }

  saveEditedProposalTDFoldcode() {
    if (this.proposalEditForm.valid && this.selectedProposalForEdit) {
      const formData = this.proposalEditForm.value;

      const sub = this.api.putAPI(`/transaction/seek/proposal/${this.selectedProposalForEdit.id}/`, formData).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Proposal updated successfully'
          });
          this.editProposalModal = false;
          this.selectedProposalForEdit = null;
          this.proposalEditForm.reset();
          // Refresh the data
          this.loadSeekSummary();
        },
        error: (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to update proposal'
          });
          console.error('Update error:', err);
        }
      });
      this.subscriptions.add(sub);
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Please fill all required fields'
      });
    }
  }
  saveEditedProposal() {
    if (this.proposalEditForm.valid && this.selectedProposalForEdit) {
       // Recalculate extension count before saving
    this.extensionCount = 0;
    if (this.extended_date1) this.extensionCount++;
    if (this.extended_date2) this.extensionCount++;
      const formData = {
        ...this.proposalEditForm.value,
        extended_date1: this.extended_date1 || null,
        extended_date2: this.extended_date2 || null
      };

      const sub = this.api.putAPI(`/transaction/seek/proposal/${this.selectedProposalForEdit.id}/`, formData).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Proposal updated successfully'
          });
          this.editProposalModal = false;
          this.selectedProposalForEdit = null;
          this.proposalEditForm.reset();
          this.extended_date1 = '';
          this.extended_date2 = '';
          this.extensionCount = 0;
          // Refresh the data
          this.loadSeekSummary();
        },
        error: (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to update proposal'
          });
          console.error('Update error:', err);
        }
      });
      this.subscriptions.add(sub);
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Please fill all required fields'
      });
    }
  }

  cancelEditProposal() {
    this.editProposalModal = false;
    this.selectedProposalForEdit = null;
    this.proposalEditForm.reset();
  }
  onFileSelect(event: any, type: string) {
    const files: File[] = event.files;

    if (type === 'draftSotr') {
      this.draftSotrFile = files[0]; // Only one file expected
    } else if (type === 'supportingDocs') {
      // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
      this.supportingDocsFiles = files[0];
    }
  }

  onUploadDraftSotr(event: any) {
    const file: File = event.files[0];
    if (file) {
      this.draftSotrFile = file;
      this.messageService.add({
        severity: 'success',
        summary: 'File attached successfully',
        detail: file.name,
      });
    }
  }

  navigateto() {
    this.router.navigate(['/scheme/tdf'], {
      queryParams: { scheme_id: 16 },
    });
  }

  onUploadSupportingDocs(event: any) {
    // const files: File[] = event.files;
    const file: File = event.files[0];
    if (file) {
      this.supportingDocsFiles = file;
    }
    // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
    this.messageService.add({
      severity: 'success',
      summary: 'Supporting Documents Uploaded',
      detail: ` files uploaded`,
    });
  }

  onDocumentUpload(event: any) {
    const files: File[] = event.files;
    if (files && files.length > 0) {
      // Add new files to existing uploaded documents
      this.uploadedDocuments = [...this.uploadedDocuments, ...files];

      // Update form control
      this.userForm.patchValue({
        uploadedDocuments: this.uploadedDocuments
      });

      // Clear the file upload component to reset its state
      this.documentUpload.clear();

      this.messageService.add({
        severity: 'success',
        summary: 'Documents Added',
        detail: `${files.length} file(s) added successfully`,
      });
    }
  }

  removeDocument(index: number) {
    this.uploadedDocuments.splice(index, 1);

    // Update form control
    this.userForm.patchValue({
      uploadedDocuments: this.uploadedDocuments
    });

    this.messageService.add({
      severity: 'info',
      summary: 'Document Removed',
      detail: 'Document removed from upload list',
    });
  }

  // formatFileSize(bytes: number): string {
  //   if (bytes === 0) return '0 Bytes';
  //   const k = 1024;
  //   const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  //   const i = Math.floor(Math.log(bytes) / Math.log(k));
  //   return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  // }

  formatFileType(fileName: string): string {
    const extension = fileName.split('.').pop()?.toUpperCase();
    return extension || 'Unknown';
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  onSubmitt() {
    let formData = new FormData();
    console.log(this.challengeForm.value)

    formData.append(
      'organisation',
      this.challengeForm.get('organisation').value
    );
    formData.append('category', this.challengeForm.get('category')?.value);
    formData.append('priority', this.challengeForm.get('priority')?.value);
    formData.append('ip_status', this.challengeForm.get('valuation')?.value || '');
    formData.append('challenge_status', this.challengeForm.get('challenge_status')?.value || '');
    formData.append(
      'release_date',
      this.challengeForm.get('releaseDate').value
    );
    if (this.challengeForm.get('approvedBy').value != null) {
      formData.append(
        'approved_by',
        this.challengeForm.get('approvedBy').value
      );
    }
    formData.append(
      'coordinated_agency',
      this.challengeForm.get('coordinatingAgency').value
    );
    formData.append(
      'technology_domain',
      this.challengeForm.get('technologyDomain').value
    );

    formData.append('title', this.challengeForm.get('challengeTitle').value);
    formData.append(
      'nodal_officer',
      this.challengeForm.get('nodalOfficer').value
    );
    formData.append(
      'problem_statement',
      this.challengeForm.get('problemStatement').value
    );
    formData.append(
      'challenge_brief',
      this.challengeForm.get('challengeBrief').value
    );
    formData.append(
      'prototype_development',
      this.challengeForm.get('prototypeDevelopment').value
    );
    formData.append('requirement', this.challengeForm.get('requirement').value);
    formData.append('ip_value', this.challengeForm.get('ipValue').value);
    formData.append(
      'functional_advantages',
      this.challengeForm.get('functionalAdvantages').value
    );
    formData.append('domestic', this.challengeForm.get('domestic').value);
    formData.append(
      'substitution',
      this.challengeForm.get('substitution').value
    );
    formData.append(
      'preliminary_scope',
      this.challengeForm.get('preliminaryScope').value
    );
    formData.append(
      'competitive_solution',
      this.challengeForm.get('competitiveSolution').value
    );
    formData.append(
      'potential_market',
      this.challengeForm.get('potentialMarket').value
    );
    formData.append(
      'risk_assessment',
      this.challengeForm.get('riskAssessment').value
    );
    formData.append('mpo_qty', this.challengeForm.get('mpoQty').value);

    if (this.draftSotrFile) {
      formData.append('pds', this.draftSotrFile);
    }

    if (this.supportingDocsFiles) {
      // this.supportingDocsFiles.forEach(file => {
      formData.append('pru', this.supportingDocsFiles); // Change key name if needed
      // });
    }
    console.log(formData, this.selectedProposal)
    let url = `/make1/need-generation/${this.selectedProposal.id}/`;

    const sub = this.api.putAPI(url, formData).subscribe({
      next: (res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Challenge Updated successfully' });
        this.gettableData()
        this.fileUpload.clear();
        this.draftSotrUpload.clear();
      },
      error: (err) => { },
    });
    this.subscriptions.add(sub);
  }
  routeModal: boolean = false;
  openRouteModal() {
    // alert('Open route configuration modal here.');
    this.routeModal = true;
    this.selectedChallenges = this.proposals.filter(p => p.selected);
    this.getRoleList()
    this.getUserList()
    this.getUnit()
    if (this.selectedChallenges.length > 0) {
      this.routeModal = true;
    }
  }

  onChallengeSelectChange(proposal: any) {
    if (proposal.selected) {
      // Add if not already in list
      if (!this.selectedChallengeCount.some(ch => ch.id === proposal.id)) {
        this.selectedChallengeCount.push(proposal);
      }
    } else {
      // Remove if unchecked
      this.selectedChallengeCount = this.selectedChallengeCount.filter(ch => ch.id !== proposal.id);
    }
  }

  onrouteFormSubmit() {
    const formValue = this.routeForm.value;
    const currentUserRole = sessionStorage.getItem('user_role_name');

    // ✅ Build payload for each selected challenge
    const payload = this.selectedChallenges.map((challenge, index) => ({
      proposal_step: currentUserRole?.toLowerCase() === 'approver' ? challenge.next_proposal_step_id : challenge.current_proposal_step,
      role: formValue.role,
      user: formValue.user,
      sequence: formValue.level,
      unit: formValue.unit,
      is_final_approve: formValue.approved || false
    }));

    console.log('Payload:', payload); // 🔍 Debug
    const sub = this.api.postAPI(`/tdf/bulk/proposal-workflow/`, payload).subscribe({
      next: (res: any) => {
        this.routeForm.reset();
        this.selectedChallenges = null
        this.routeModal = false;
        this.gettableData()
      },
      error: (err) => {
        console.error('Update failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.detail || 'Something went wrong while updating the mapping.',
        });
      }
    });
    this.subscriptions.add(sub);
  }
  submitIRA() {
    let role_id = sessionStorage.getItem('user_role_id')
    const payload = this.selectedChallenges.map((challenge, index) => ({
      proposal_step: challenge.current_proposal_step,
      role_id: Number(role_id),
      is_approved: true,
      remark: this.IRAremarks
    }));
    console.log("ira", payload)
    this.IRAremarks = ''
    const sub = this.api.postAPI(`/tdf/bulk/proposal-ira-action/`, payload).subscribe((res: any) => {
      this.isEditable = false;
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Proposal added successfully' });

    })
    this.subscriptions.add(sub);

  }
  getRoleList() {
    const currentUserRole = sessionStorage.getItem('user_role_name'); // e.g. "initiator", "rec", "approver"

    const rolePriority = ['INT', 'REC', 'APP']; // desired order

    this.api.getAPI('/access/user-roles/').subscribe((res: any) => {
      const resp = res.data;

      // Base filter: only roles that exist in priority
      let roles = resp.filter(role => rolePriority.includes(role.code));

      // Apply visibility rules
      if (currentUserRole?.toLowerCase() === 'initiator') {
        roles = roles.filter(r => r.code === 'REC' || r.code === 'APP');
      } else if (currentUserRole?.toLowerCase() === 'rec') {
        roles = roles.filter(r => r.code === 'REC' || r.code === 'APP');
      } else if (currentUserRole?.toLowerCase() === 'approver') {
        roles = roles.filter(r => r.code === 'INT');
      }

      // Sort roles in defined priority order
      this.roleList = roles.sort(
        (a, b) => rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code)
      );
    });
  }

  getUserList() {
    const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
      this.userList = res.data;
      this.userListCopy = [...this.userList]
    })
    this.subscriptions.add(sub);
  }
  getUnit() {
    const sub = this.api.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
    })
    this.subscriptions.add(sub);
  }
  onRoleChange(event: any) {
    // this.roleID = event.value;
    this.tryFetchingSequence();
  }

  onUserChange(event: any) {
    // this.userID = event.value;
    this.tryFetchingSequence();
  }
  onUnitChange(event: any) {
    let unit_id = event.value
    this.userList = this.userListCopy.filter(user => user.unit?.id == unit_id);
  }
  tryFetchingSequence() {
    const step = this.selectedChallenges[0].current_proposal_step;
    const role = this.routeForm.get('role').value;
    const user = this.routeForm.get('user').value;
    if (step && role && user) {
      this.getSequence();
    }
  }

  getSequence() {
    const step = this.selectedChallenges[0].current_proposal_step;
    const role = this.routeForm.get('role').value;
    const user = this.routeForm.get('user').value;
    const sub = this.api.getAPI(`/transaction/get-next-level/?proposal_step_id=${step}&role_id=${role}`)
      .subscribe((res: any) => {
        const sequenceValue = res.level ?? '';
        this.routeForm.get('level')?.patchValue(sequenceValue);
      });
    this.subscriptions.add(sub);
  }


  activeTab: string = 'upload';
  selectedProposals: string[] = [];
  showReviewModal: boolean = false;
  showActionModal: boolean = false;

  milestoneproposals = [
    { id: 'PROP001', title: 'AI Research Initiative', status: 'Active', milestones: 5, progress: 60, nextDeadline: '2024-10-15' },
    { id: 'PROP002', title: 'Defense Technology Project', status: 'Active', milestones: 8, progress: 25, nextDeadline: '2024-09-20' },
    { id: 'PROP003', title: 'Cyber Security Enhancement', status: 'Review', milestones: 6, progress: 80, nextDeadline: '2024-09-30' }
  ];

  wbsVersions = [
    { version: 'v1.0', uploadDate: '2024-08-15', status: 'Active', uploader: 'John Doe' },
    { version: 'v1.1', uploadDate: '2024-08-25', status: 'Draft', uploader: 'Jane Smith' }
  ];

  tranchePayments = [
    { milestone: 'Milestone 1', percentage: 20, amount: 100000, dueDate: '2024-09-15', status: 'Completed' },
    { milestone: 'Milestone 2', percentage: 30, amount: 150000, dueDate: '2024-10-15', status: 'Pending' },
    { milestone: 'Milestone 3', percentage: 25, amount: 125000, dueDate: '2024-11-15', status: 'Upcoming' }
  ];

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  toggleProposalSelection(id: string, checked: boolean) {
    if (checked) {
      this.selectedProposals.push(id);
    } else {
      this.selectedProposals = this.selectedProposals.filter(p => p !== id);
    }
  }
  proposalSteps: { id: number, nextStep: number }[] = [];

  addProposalStep(proposal: any) {
    this.proposalSteps.push({
      id: proposal.id,
      nextStep: proposal.next_proposal_step_id
    });
  }

  items: any;
  selectedItem: any;
  //   getUserData() {
  //   const sub = this.api
  //     .getAPI('/account/users/?user_role__code=PDIRECTORATE')
  //     .subscribe((res: any) => {
  //       this.items = res?.data || [];
  //     });
  //   this.subscriptions.add(sub);

  // }

  // Add Directorate Methods
  openAddDirectorateModal() {
    this.addDirectorateModal = true;
    this.directorateForm.reset();
  }

  cancelAddDirectorate() {
    this.addDirectorateModal = false;
    this.directorateForm.reset();
    this.isAddingDirectorate = false;
  }

  saveNewDirectorate() {
    if (this.directorateForm.valid) {
      this.isAddingDirectorate = true;

      const payload = {
        name: this.directorateForm.get('name')?.value,
        code: this.directorateForm.get('code')?.value,
        // description: this.directorateForm.get('description')?.value || ''
      };

      console.log('Adding new directorate:', payload);

      const sub = this.api.postAPI('/master/units/', payload).subscribe({
        next: (res: any) => {
          this.isAddingDirectorate = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Directorate added successfully!'
          });

          // Close modal and reset form
          this.addDirectorateModal = false;
          this.directorateForm.reset();

          // Refresh the unit list to include the new directorate
          this.getUnit();

          // Optionally select the newly added directorate
          if (res.data && res.data.id) {
            // Check if we're in the seek proposal modal or edit proposal modal
            if (this.displayDialog) {
              // Seek proposal modal
              const currentDirectorates = this.userForm.get('directorate')?.value || [];
              this.userForm.get('directorate')?.setValue([...currentDirectorates, res.data.id]);
            } else if (this.editProposalModal) {
              // Edit proposal modal
              const currentDirectorates = this.proposalEditForm.get('directorate')?.value || [];
              this.proposalEditForm.get('directorate')?.setValue([...currentDirectorates, res.data.id]);
            }
          }
        },
        error: (err: any) => {
          this.isAddingDirectorate = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to add directorate. Please try again.'
          });
          console.error('Add Directorate Error:', err);
        }
      });

      this.subscriptions.add(sub);
    } else {
      // Mark all fields as touched to show validation errors
      Object.keys(this.directorateForm.controls).forEach(key => {
        const control = this.directorateForm.get(key);
        control?.markAsTouched();
      });

      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Please fill all required fields correctly'
      });
    }
  }

  // Received Proposals Methods
  viewReceivedProposals(proposal: any) {
    this.selectedSeekProposal = proposal;
    this.receivedProposalsModal = true;
    this.loadReceivedProposals(proposal.id);
  }

  loadReceivedProposals(seekId: number) {
    this.isLoadingReceivedProposals = true;
    this.receivedProposalsError = '';
    this.receivedProposalsList = [];

    const sub = this.api.getAPI(`/tdf/needgeneration/by-seekproposal/?seek_id=${seekId}`).subscribe({
      next: (res: any) => {
        this.isLoadingReceivedProposals = false;
        console.log('Received proposals API response:', res);

        if (res && Array.isArray(res)) {
          this.receivedProposalsList = res;
          console.log('Received proposals list:', this.receivedProposalsList);

          if (this.receivedProposalsList.length === 0) {
            this.messageService.add({
              severity: 'info',
              summary: 'No Proposals Found',
              detail: 'No received proposals found for this seek proposal.'
            });
          }
        } else {
          this.receivedProposalsList = [];
          console.log('No valid data received, setting empty array');
          this.messageService.add({
            severity: 'info',
            summary: 'No Proposals Found',
            detail: 'No received proposals found for this seek proposal.'
          });
        }
      },
      error: (err: any) => {
        this.isLoadingReceivedProposals = false;
        this.receivedProposalsError = err?.error?.detail || 'Failed to load received proposals. Please try again.';

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: this.receivedProposalsError
        });

        console.error('Load Received Proposals Error:', err);
      }
    });

    this.subscriptions.add(sub);
  }

  closeReceivedProposalsModal() {
    this.receivedProposalsModal = false;
    this.selectedSeekProposal = null;
    this.receivedProposalsList = [];
    this.receivedProposalsError = '';
    this.isLoadingReceivedProposals = false;
  }

  getPlainText(htmlString: string): string {
    if (!htmlString) return '';
    // Create a temporary div element to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  truncateTitle(htmlString: string, wordCount: number = 3): string {
    if (!htmlString) return '';
    const plainText = this.getPlainText(htmlString);
    const words = plainText.trim().split(/\s+/);

    if (words.length <= wordCount) {
      return plainText;
    }

    return words.slice(0, wordCount).join(' ') + '...';
  }

  // Document Viewer Methods
  viewUploadedDocuments(proposal: any) {
    this.selectedProposalForFiles = proposal;
    this.fileDownloadModal = true;
    this.loadUploadedFiles(proposal.id);
  }

  // File Download Modal Methods
  loadUploadedFiles(seekId: number) {
    this.uploadedFilesList = [];

    // Find the proposal data from the existing proposalDataList
    const proposal = this.proposalDataList.find(p => p.id === seekId);

    if (proposal && proposal.seek_file && Array.isArray(proposal.seek_file)) {
      // Process the seek_file array to create file list
      this.uploadedFilesList = proposal.seek_file.map((file: any, index: number) => {
        // Extract file name from the file path
        const fileName = file.file.split('/').pop() || `document_${index + 1}`;

        return {
          id: file.id,
          file_name: fileName,
          file_path: file.file,
          uploaded_at: file.created_at || new Date()
        };
      });
    }
  }

  closeFileDownloadModal() {
    this.fileDownloadModal = false;
    this.selectedProposalForFiles = null;
    this.uploadedFilesList = [];
  }

  loadUploadedDocuments(seekId: number) {
    this.isLoadingDocuments = true;
    this.documentViewerError = '';
    this.uploadedDocumentsList = [];

    // Find the proposal data from the existing proposalDataList
    const proposal = this.proposalDataList.find(p => p.id === seekId);

    if (proposal && proposal.seek_file && Array.isArray(proposal.seek_file)) {
      // Process the seek_file array to create document list
      this.uploadedDocumentsList = proposal.seek_file.map((file: any, index: number) => {
        // Extract file name from the file path
        const fileName = file.file.split('/').pop() || `document_${index + 1}`;

        return {
          id: file.id,
          file_name: fileName,
          file_path: file.file,
          file_size: 0, // File size not provided in API, set to 0
          uploaded_at: new Date(file.uploaded_at),
          file_type: this.getFileTypeFromName(fileName)
        };
      });

      this.isLoadingDocuments = false;

      if (this.uploadedDocumentsList.length === 0) {
        this.messageService.add({
          severity: 'info',
          summary: 'No Documents Found',
          detail: 'No uploaded documents found for this seek proposal.'
        });
      }
    } else {
      // No documents found for this proposal
      this.uploadedDocumentsList = [];
      this.isLoadingDocuments = false;

      this.messageService.add({
        severity: 'info',
        summary: 'No Documents Found',
        detail: 'No uploaded documents found for this seek proposal.'
      });
    }
  }

  closeDocumentViewerModal() {
    this.documentViewerModal = false;
    this.selectedProposalForDocs = null;
    this.uploadedDocumentsList = [];
    this.documentViewerError = '';
    this.isLoadingDocuments = false;
  }


  downloadDocument(document: any) {
    // Create download link using window.document
    const link = window.document.createElement('a');
    link.href = this.getDocumentUrl(document.file_path);
    link.download = document.file_name;
    link.target = '_blank';
    window.document.body.appendChild(link);
    link.click();
    window.document.body.removeChild(link);

    this.messageService.add({
      severity: 'success',
      summary: 'Download Started',
      detail: `Downloading ${document.file_name}`
    });
  }

  getDocumentUrl(filePath: string): string {
    return `${this.apiUrl}${filePath}`;
  }

  getDocumentIcon(fileName: string): string {
    const extension = this.getFileExtension(fileName).toLowerCase();

    switch (extension) {
      case 'pdf':
        return 'pi pi-file-pdf';
      case 'doc':
      case 'docx':
        return 'pi pi-file-word';
      case 'xls':
      case 'xlsx':
        return 'pi pi-file-excel';
      case 'ppt':
      case 'pptx':
        return 'pi pi-file-powerpoint';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'pi pi-image';
      case 'zip':
      case 'rar':
        return 'pi pi-file-archive';
      case 'txt':
        return 'pi pi-file-text';
      default:
        return 'pi pi-file';
    }
  }

  getFileExtension(fileName: string): string {
    return fileName.split('.').pop()?.toUpperCase() || 'Unknown';
  }

  truncateFileName(fileName: string, maxLength: number): string {
    if (fileName.length <= maxLength) {
      return fileName;
    }

    const extension = this.getFileExtension(fileName);
    const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
    const truncatedName = nameWithoutExt.substring(0, maxLength - extension.length - 4);

    return `${truncatedName}...${extension}`;
  }


  getFileTypeFromName(fileName: string): string {
    const extension = this.getFileExtension(fileName).toLowerCase();

    switch (extension) {
      case 'pdf':
        return 'application/pdf';
      case 'doc':
        return 'application/msword';
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'xls':
        return 'application/vnd.ms-excel';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      case 'ppt':
        return 'application/vnd.ms-powerpoint';
      case 'pptx':
        return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'png':
        return 'image/png';
      case 'gif':
        return 'image/gif';
      case 'zip':
        return 'application/zip';
      case 'txt':
        return 'text/plain';
      default:
        return 'application/octet-stream';
    }
  }
  onYearChange(year: number) {
    this.getDashboardData(year);
  }

  // New Dashboard Data Loading Methods
  loadNewDashboardData() {
    this.dashboardLoading = true;
    this.getSummaryMetrics();
    this.getGrantSummary();
    this.getMilestoneData();
  }

  getSummaryMetrics() {
    const schemeId = this.schemeID ?? 16;
    this.api.getAPI(`/make1/dashboard/summary/?scheme_id=${schemeId}`).subscribe({
      next: (res: any) => {
        // Initial cards: map MAKE summary API keys (apso_approve, vcns_approve, short_close, etc.)
        this.totalContracts = res.hasOwnProperty('total_grant') ? Number(res.total_grant) : 0;
        this.totalProposals = res.hasOwnProperty('total_proposal') ? Number(res.total_proposal) : 0;
        this.totalPreLaunch = res.hasOwnProperty('apso_approve') ? Number(res.apso_approve) : (res.hasOwnProperty('total_pre_launch') ? Number(res.total_pre_launch) : 0);
        this.totalForLaunch = res.hasOwnProperty('vcns_approve') ? Number(res.vcns_approve) : (res.hasOwnProperty('total_for_launch') ? Number(res.total_for_launch) : 0);
        this.totalPostLaunch = res.hasOwnProperty('total_post_launch') ? Number(res.total_post_launch) : 0;
        this.completedProposals = res.hasOwnProperty('completed_proposal') ? Number(res.completed_proposal) : 0;
        this.totalShortClosed = res.hasOwnProperty('short_close') ? Number(res.short_close) : 0;
        
        // Scheme-wise data (MAKE keys: scheme_wise_apso, scheme_wise_vcns, scheme_wise_shortclose)
        this.schemeWiseGrant = res.scheme_wise_grant || {};
        this.schemeWiseProposal = res.scheme_wise_proposal || {};
        this.schemeWisePrelaunch = res.scheme_wise_apso || res.scheme_wise_prelaunch || {};
        this.schemeWiseForlaunch = res.scheme_wise_vcns || res.scheme_wise_forlaunch || {};
        this.schemeWisePostlaunch = res.scheme_wise_postlaunch || {};
        this.schemeWiseCompleted = res.scheme_wise_completed || {};
        this.schemeWiseShortClosed = res.scheme_wise_shortclose || {};

        // Proposal Progress Across Major TDF Stages: build from proposal_data (or scheme_stage_counts fallback)
        const stageLabels = this.stageProgressChart.labels;
        let pendingData = stageLabels.map(() => 0);
        let inProgressData = stageLabels.map(() => 0);
        let completedData = stageLabels.map(() => 0);
        const stageFields = ['aip', 'feasibility_study', 'aon', 'eoi_pso', 'prototype_development', 'ssct', 'rfp_cnc'];
        const currentStageToIndex = (currentStage: string): number => {
          const s = (currentStage || '').toLowerCase();
          if (s.includes('aip') || s.includes('apso')) return 0;
          if (s.includes('feasibility')) return 1;
          if (s.includes('aon') || s.includes('mom') || s.includes('ddp')) return 2;
          if (s.includes('eoi') || s.includes('pso') || s.includes('evaluation')) return 3;
          if (s.includes('prototype')) return 4;
          if (s.includes('ssct')) return 5;
          if (s.includes('rfp') || s.includes('cnc') || s.includes('contract') || s.includes('soc') || s.includes('questionnaire')) return 6;
          return -1;
        };
        const rawProposalsForChart = Array.isArray(res.proposal_data) ? res.proposal_data : [];
        if (rawProposalsForChart.length > 0) {
          rawProposalsForChart.forEach((p: any) => {
            const currentStageIndex = currentStageToIndex(p.current_stage || '');
            stageFields.forEach((field: string, i: number) => {
              const raw = (p[field] || '').toString().toLowerCase();
              if (raw.includes('complete')) {
                completedData[i] = (completedData[i] || 0) + 1;
              } else if (i === currentStageIndex) {
                inProgressData[i] = (inProgressData[i] || 0) + 1;
              } else {
                pendingData[i] = (pendingData[i] || 0) + 1;
              }
            });
          });
        } else {
          const schemeStageCounts = res.scheme_stage_counts || {};
          const stageCountKeys: Record<number, string> = {
            0: 'AIP', 1: 'FEASIBILITY', 2: 'AON', 3: 'EOI', 4: 'PROTOTYPE', 5: 'SSCT', 6: 'RFP_CNC'
          };
          for (let i = 0; i < 7; i++) {
            const key = stageCountKeys[i];
            const stageObj = schemeStageCounts[key];
            const total = stageObj && typeof stageObj === 'object' && typeof stageObj.total === 'number'
              ? stageObj.total : 0;
            inProgressData[i] = total;
          }
        }
        this.stageProgressChart = {
          ...this.stageProgressChart,
          datasets: [
            { ...this.stageProgressChart.datasets[0], data: pendingData },
            { ...this.stageProgressChart.datasets[1], data: inProgressData },
            { ...this.stageProgressChart.datasets[2], data: completedData }
          ]
        };

        // Proposal-wise Stage Tracking table: only from make1/dashboard/summary proposal_data (scheme_id=16)
        const rawProposals = Array.isArray(res.proposal_data) ? res.proposal_data : [];
        this.stageTrackingProposalData = rawProposals.map((p: any) => {
          const stageStatusMap: any = {
            AIP: p.aip,
            FEASIBILITY: p.feasibility_study,
            AON: p.aon,
            EOI_PSO: p.eoi_pso,
            PROTOTYPE: p.prototype_development,
            SSCT: p.ssct,
            RFP_CNC: p.rfp_cnc
          };
          return {
            ...p,
            name: p.name || p.proposal_name || p.title,
            scheme_name: p.scheme_name,
            current_stage: p.current_stage,
            overall_status: p.overall_status,
            stage_status: p.stage_status || stageStatusMap,
            updated_at: p.updated_at || p.last_updated_on,
            stage_updated_at: p.stage_updated_at || p.last_updated_on
          };
        });
        this.applyStageTrackingFilter();

        // Seek Proposal Response Analytics & Overall Directorate Response Summary from same API when present
        const directorateResponseGraph = res.directorate_response_graph;
        const seekProposals = res.seek_proposals;
        const seekCycles = res.seek_cycles;
        if (directorateResponseGraph && Array.isArray(directorateResponseGraph)) {
          const formatSeekLabel = (d: any) => {
            const dateRaw = d.seek_date ?? d.end_date ?? d.date;
            if (d.label) return d.label;
            if (dateRaw) {
              const dt = new Date(dateRaw);
              return !isNaN(dt.getTime()) ? dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' }) : dateRaw;
            }
            return d.name || '';
          };
          const labels = directorateResponseGraph.map(formatSeekLabel);
          const proposalSubmitted = directorateResponseGraph.map((d: any) => d.proposal_submitted_count ?? d.proposal_submitted ?? 0);
          const nilReturn = directorateResponseGraph.map((d: any) => d.nil_return_count ?? d.nil_return_submitted ?? d.nil_return ?? 0);
          const defaultTotalDirectorates = Number(res.total_directorates_involved ?? 0);
          const noResponse = directorateResponseGraph.map((d: any) => {
            const no = d.no_response_received ?? d.no_response_count ?? d.no_response_submitted ?? d.no_response;
            if (typeof no === 'number') return no;
            const total = d.total_directorates ?? d.directorate_count ?? defaultTotalDirectorates;
            const sub = d.proposal_submitted_count ?? d.proposal_submitted ?? 0;
            const nil = d.nil_return_count ?? d.nil_return_submitted ?? d.nil_return ?? 0;
            return Math.max(0, total - sub - nil);
          });
          this.seekDirectorateResponseChart = {
            ...this.seekDirectorateResponseChart,
            labels: labels.length ? labels : ['No data'],
            datasets: [
              { ...this.seekDirectorateResponseChart.datasets[0], data: labels.length ? proposalSubmitted : [0] },
              { ...this.seekDirectorateResponseChart.datasets[1], data: labels.length ? nilReturn : [0] },
              { ...this.seekDirectorateResponseChart.datasets[2], data: labels.length ? noResponse : [0] }
            ]
          };
          const totalSub = proposalSubmitted.reduce((s: number, n: number) => s + n, 0);
          const totalNil = nilReturn.reduce((s: number, n: number) => s + n, 0);
          const totalNo = noResponse.reduce((s: number, n: number) => s + n, 0);
          const total = totalSub + totalNil + totalNo;
          const doughnutData = total > 0 ? [totalSub, totalNil, totalNo] : [1, 1, 1];
          this.seekResponseSummaryDoughnutChart = {
            ...this.seekResponseSummaryDoughnutChart,
            datasets: [{ data: doughnutData, backgroundColor: ['#22C55E', '#F59E0B', '#94A3B8'], hoverOffset: 4 }]
          };
          this.seekAnalyticsRawCycles = directorateResponseGraph.map((d: any, i: number) => {
            const dateRaw = d.seek_date ?? d.end_date ?? d.date;
            const endDate = dateRaw ? new Date(dateRaw) : null;
            const sub = d.proposal_submitted_count ?? d.proposal_submitted ?? 0;
            const nil = d.nil_return_count ?? d.nil_return_submitted ?? d.nil_return ?? 0;
            const totalDir = d.total_directorates ?? d.directorate_count ?? defaultTotalDirectorates;
            const noResp = d.no_response_received ?? d.no_response_count ?? d.no_response ?? Math.max(0, totalDir - sub - nil);
            return {
              endDate: endDate && !isNaN(endDate.getTime()) ? endDate : null,
              seekDateLabel: formatSeekLabel(d) || `Cycle ${i + 1}`,
              totalDirectorates: totalDir,
              proposalSubmitted: sub,
              nilReturn: nil,
              noResponse: noResp
            };
          });
        } else if (Array.isArray(seekCycles) && seekCycles.length > 0) {
          this.seekAnalyticsRawCycles = seekCycles.map((c: any) => ({
            endDate: c.end_date ? new Date(c.end_date) : null,
            seekDateLabel: c.label || (c.end_date ? new Date(c.end_date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' }) : ''),
            totalDirectorates: c.directorate_count ?? 0,
            proposalSubmitted: c.proposal_submitted_count ?? 0,
            nilReturn: c.nil_return_count ?? 0,
            noResponse: c.no_response_count ?? 0
          }));
          this.buildSeekAnalyticsCharts();
        } else if (Array.isArray(seekProposals) && seekProposals.length > 0) {
          // Seek proposal table is loaded only from /transaction/seek/proposal/?scheme_id=16 (getProposalData); load charts via seek summary.
          this.loadSeekSummary();
        } else {
          // Fallback: load seek data from make1/seek/summary so charts still populate
          this.loadSeekSummary();
        }

        this.dashboardLoading = false;
        console.log('TDF Summary metrics loaded from make1/dashboard/summary:', { totalContracts: this.totalContracts, totalProposals: this.totalProposals, stageTrackingProposalDataLength: this.stageTrackingProposalData.length });
      },
      error: (err) => {
        console.error('Error fetching make1 dashboard summary:', err);
        this.dashboardLoading = false;
        this.totalContracts = 0;
        this.totalProposals = 0;
        this.totalPreLaunch = 0;
        this.totalForLaunch = 0;
        this.totalPostLaunch = 0;
        this.completedProposals = 0;
        this.totalShortClosed = 0;
        this.stageTrackingProposalData = [];
        this.applyStageTrackingFilter();
        this.schemeWiseGrant = {};
        this.schemeWiseProposal = {};
        this.schemeWisePrelaunch = {};
        this.schemeWiseForlaunch = {};
        this.schemeWisePostlaunch = {};
        this.schemeWiseCompleted = {};
        this.schemeWiseShortClosed = {};
      }
    });
  }

  getGrantSummary() {
    const schemeId = this.schemeID ?? 16;
    this.api.getAPI(`/make1/dashboard/grants/?scheme_id=${schemeId}`).subscribe({
      next: (res: any) => {
        this.totalGrantsApproved = res.total_grant_approved || 0;
        this.totalGrantsSpent = res.total_grant_spent || 0;
        this.totalGrantsPending = res.total_grant_pending || 0;
        
        // Store scheme-wise data
        this.schemeWiseApproved = res.scheme_wise_approved || {};
        this.schemeWiseSpent = res.scheme_wise_spent || {};
        this.schemeWisePending = res.scheme_wise_pending || {};
        
        console.log('TDF Grant summary loaded:', res);
      },
      error: (err) => {
        console.error('Error fetching TDF grant summary:', err);
        this.totalGrantsApproved = 0;
        this.totalGrantsSpent = 0;
        this.totalGrantsPending = 0;
        this.schemeWiseApproved = {};
        this.schemeWiseSpent = {};
        this.schemeWisePending = {};
      }
    });
  }

  getMilestoneData() {
    this.api.getAPI(`/make1/monitoring/module/`).subscribe({
      next: (res: any) => {
        // Map the response similar to monitoring-module
        if (Array.isArray(res)) {
          this.milestoneData = res.map((item, index) => this.mapMilestoneData(item, index));
        } else {
          this.milestoneData = [this.mapMilestoneData(res, 0)];
        }
      },
      error: () => {
        this.milestoneData = [];
      }
    });
  }

  // Map API response to milestone table row format
  mapMilestoneData(response: any, index: number): any {
    const row: any = {
      ser: index + 1,
      challenge: response.challenge?.title || '',
      firmDetails: response.vendor?.company_name 
        ? `${response.vendor.company_name} (${response.vendor.phone_number || ''})`
        : '',
    };

    // Map MS 00 to MS 05
    for (let i = 0; i <= 5; i++) {
      const milestone = response.milestones?.[i];
      if (milestone) {
        const disbursedAmount = milestone.disbursed_amount ?? '-';
        const actualDate = milestone.actual_date
          ? new Date(milestone.actual_date).toLocaleDateString('en-GB')
          : '-';
        row[`ms_${i.toString().padStart(2, '0')}`] = `₹${disbursedAmount} | ${actualDate}`;
      } else {
        row[`ms_${i.toString().padStart(2, '0')}`] = '';
      }
    }

    return row;
  }

  onProjectFilterChange(filter: string) {
    this.selectedProjectFilter = filter;
    // You can add additional filtering logic here if needed
  }
  getDashboardData(year: number) {
    const schemeId = this.schemeID ?? 16;
    this.api
      .getAPI(
        `/make1/dashboard/details/?scheme_id=${schemeId}&year=${year}`
      )
      .subscribe({
        next: (res: any) => {
          // Chart 1: Year-wise Proposals vs Completed (same structure as MAKE make1/dashboard/details)
          const yearlyReceived = res.yearly_received_vs_completed || {};
          const yearlyData = yearlyReceived[String(year)] || yearlyReceived['2025'] || [];
          this.chartData1 = {
            labels: yearlyData.map((d: any) => d.scheme_name),
            datasets: [
              {
                label: 'Received',
                backgroundColor: '#42A5F5',
                data: yearlyData.map((d: any) => d.received),
              },
              {
                label: 'Approved',
                backgroundColor: '#66BB6A',
                data: yearlyData.map((d: any) => d.approved),
              },
              {
                label: 'Rejected',
                backgroundColor: '#EF5350',
                data: yearlyData.map((d: any) => d.rejected),
              },
            ],
          };

          // Chart 2: Schemes - Received/In Progress/Completed
          const schemeStatus = res.schemes_proposal_status || [];
          this.chartData2 = {
            labels: schemeStatus.map((d: any) => d.scheme__name),
            datasets: [
              {
                label: 'Received',
                backgroundColor: '#42A5F5',
                data: schemeStatus.map((d: any) => d.received),
              },
              {
                label: 'In Progress',
                backgroundColor: '#FFB300',
                data: schemeStatus.map((d: any) => d.in_progress),
              },
              {
                label: 'Completed',
                backgroundColor: '#66BB6A',
                data: schemeStatus.map((d: any) => d.completed),
              },
              {
                label: 'Rejected',
                backgroundColor: '#EF5350',
                data: schemeStatus.map((d: any) => d.rejected),
              },
            ],
          };

          // Chart 3: Funds Utilised (dummy for now, API not provided)
          this.chartData3 = {
            labels: ['2021', '2022', '2023', '2024', '2025'],
            datasets: [
              {
                label: 'Funds Utilised',
                borderColor: '#42A5F5',
                fill: false,
                data: [100, 200, 150, 300, 400],
                tension: 0,
              },
            ],
          };

          // Chart 6: Proposal Value vs Disbursed Funds (dummy, no values in API yet)
          this.chartData6 = {
            labels: ['Scheme A', 'Scheme B', 'Scheme C'],
            datasets: [
              {
                label: 'Proposal Value',
                backgroundColor: '#42A5F5',
                data: [300, 200, 400], // placeholder
              },
              {
                label: 'Disbursed Funds',
                backgroundColor: '#66BB6A',
                data: [200, 150, 350], // placeholder
              },
            ],
          };

          // Chart 4: Proposals Detailed View (Pie - based on status count)
          const proposals = res.proposals_detail || [];
          const statusCount: any = {};
          proposals.forEach((p: any) => {
            statusCount[p.proposal_status] =
              (statusCount[p.proposal_status] || 0) + 1;
          });
          this.chartData4 = {
            labels: Object.keys(statusCount),
            datasets: [
              {
                data: Object.values(statusCount),
                backgroundColor: ['#42A5F5', '#66BB6A', '#FFB300', '#EF5350'],
              },
            ],
          };

          // Chart 5: Sub-module Wise Proposal Distribution (Doughnut - by scheme)
          const schemeCount: any = {};
          proposals.forEach((p: any) => {
            schemeCount[p.scheme__name] =
              (schemeCount[p.scheme__name] || 0) + 1;
          });
          this.chartData5 = {
            labels: Object.keys(schemeCount),
            datasets: [
              {
                data: Object.values(schemeCount),
                backgroundColor: ['#42A5F5', '#66BB6A', '#FFB300', '#AB47BC'],
              },
            ],
          };
          // compute counts
          const totalReceived = schemeStatus.reduce(
            (sum, s) => sum + (s.received || 0),
            0
          );
          const totalInProgress = schemeStatus.reduce(
            (sum, s) => sum + (s.in_progress || 0),
            0
          );
          const totalCompleted = schemeStatus.reduce(
            (sum, s) => sum + (s.completed || 0),
            0
          );
          const totalRejected = schemeStatus.reduce(
            (sum, s) => sum + (s.rejected || 0),
            0
          );

          this.statusCards = [
            {
              label: 'Total Received',
              count: totalReceived,
              icon: 'pi pi-inbox',
              color: '#007bff',
            }, // Blue
            {
              label: 'In Progress',
              count: totalInProgress,
              icon: 'pi pi-spin pi-spinner',
              color: '#ffc107',
            }, // Yellow
            {
              label: 'Completed',
              count: totalCompleted,
              icon: 'pi pi-check-circle',
              color: '#28a745',
            }, // Green
            {
              label: 'Rejected',
              count: totalRejected,
              icon: 'pi pi-times-circle',
              color: '#dc3545',
            }, // Red
            // {
            //   label: 'Total Proposals',
            //   count: proposals.length,
            //   icon: 'pi pi-file',
            //   color: '#17a2b8',
            // }, // Teal
            // {
            //   label: 'Schemes Active',
            //   count: schemeStatus.length,
            //   icon: 'pi pi-briefcase',
            //   color: '#6f42c1',
            // }, // Purple
          ];
        },
      });
  }
  onApprove(proposal: any) {
    // Mark the selected proposal in filteredProposals
    this.filteredProposals = this.filteredProposals.map((p) => ({
      ...p,
      isSelected: p === proposal,
    }));

    // Set selectedChallenges as array
    this.selectedChallenges = [proposal];

    // Show the modal
    this.routeModal = true;
  }

  // Helper methods for directorate display
  getDirectorateDisplayText(directorates: any[]): string {
    if (!directorates || directorates.length === 0) {
      return '-';
    }

    if (directorates.length <= 2) {
      return directorates.map(dir => dir.name).join(', ');
    }

    // Show first 2 names and indicate more
    const firstTwo = directorates.slice(0, 2).map(dir => dir.name).join(', ');
    return firstTwo;
  }

  getDirectorateTooltip(directorates: any[]): string {
    if (!directorates || directorates.length <= 2) {
      return '';
    }
    return directorates.map(dir => dir.name).join(', ');
  }

  getDirectorateCount(directorates: any[]): number {
    return directorates?.length ?? 0;
  }

  showDirectorateList(event: Event, directorates: any[]): void {
    this.selectedDirectorateList = directorates || [];
    this.directoratePanel?.toggle(event);
  }

  getRemarksDisplay(remark: string | null | undefined): string {
    const text = remark?.trim() || '—';
    if (text.length <= 200) return text;
    return text.slice(0, 200) + '...';
  }

  hasLongRemark(remark: string | null | undefined): boolean {
    const text = remark?.trim();
    return !!(text && text.length > 200);
  }

  showFullRemark(event: Event, remark: string | null | undefined): void {
    this.selectedRemarkFullText = remark?.trim() || '—';
    this.remarkPanel?.toggle(event);
  }

  getRemarkTooltip(remark: string | null | undefined): string {
    const text = remark?.trim() || '—';
    if (text.length <= 500) return text;
    return text.slice(0, 500) + '...';
  }

  isDateExtended(proposal: any): boolean {
    return !!(proposal?.extended_date1 || proposal?.extended_date2);
  }

  getExtendedDatesList(proposal: any): string[] {
    const out: string[] = [];
    if (proposal?.extended_date1) {
      out.push(new Date(proposal.extended_date1).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }));
    }
    if (proposal?.extended_date2) {
      out.push(new Date(proposal.extended_date2).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }));
    }
    return out;
  }

  // Search functionality methods
  onSearchInput(value: string) {
    this.searchText = value.trim();
    this.applySearchFilter();
  }

  onEnterSearch(value: string) {
    this.searchText = value.trim();
    this.applySearchFilter();
  }

  clearSearch() {
    this.searchText = '';
    this.filteredProposalDataList = [...this.proposalDataList];
  }

  applySearchFilter() {
    if (!this.searchText) {
      this.filteredProposalDataList = [...this.proposalDataList];
      return;
    }

    const searchTerm = this.searchText.toLowerCase();
    this.filteredProposalDataList = this.proposalDataList.filter(proposal => {
      // Search in description/remark
      const description = (proposal.remark || '').toLowerCase();

      // Search in directorate names
      const directorateNames = proposal.directorate
        ? proposal.directorate.map((dir: any) => dir.name).join(' ').toLowerCase()
        : '';

      // Search in end date
      const endDate = proposal.end_date ? new Date(proposal.end_date).toLocaleDateString().toLowerCase() : '';

      return description.includes(searchTerm) ||
        directorateNames.includes(searchTerm) ||
        endDate.includes(searchTerm);
    });
  }
extensionCount = 0;
  extensionDate: any = '';
  extended_date1: string = '';
  extended_date2: string = '';
   isExtDate2FromBackend: any;
  isExtDate1Saved: any;
  nilReturnList: any;
  showDeleteDialog = false;
  selectedProposalForEditNilReturns : any = null;
  editNilReturnModal: boolean = false;
  openEditSeekProposal(proposal: any) {
    this.selectedProposalForEdit = proposal;
    console.log('Editing seek proposal:', this.selectedProposalForEdit);
    this.editProposalModal = true;

    // Populate the form with existing data
    this.proposalEditForm.patchValue({
      start_date: proposal.start_date,
      end_date: proposal.end_date,
      remark: proposal.remark,
      directorate: proposal.directorate?.map((d: any) => d.id),
      status: proposal.status
    });

    // Set extension dates from the proposal
    this.extended_date1 = proposal.extended_date1 || '';
    this.extended_date2 = proposal.extended_date2 || '';
    this.extensionDate = '';
    this.extensionCount = (this.extended_date1 ? 1 : 0) + (this.extended_date2 ? 1 : 0);
    this.isExtDate2FromBackend = !!proposal.extended_date2; 
    this.isExtDate1Saved = !!proposal.extended_date1;
  }
editRemark: string = '';
selectedNilReturnId: number | null = null;
  openEditSeekProposalNilReturns(proposal: any){
    this.selectedProposalForEditNilReturns = proposal;
     this.nilReturnList = [];           // reset before loading
  this.selectedNilReturnId = null;  
    this.editNilReturnModal = true;
    this.getNilReturns(proposal.id);
  }
  getNilReturns(seekId: number) {

  const url = `/transaction/seek/nil-return/?seek=${seekId}`;

  this.api.getAPI(url).subscribe({
    next: (res: any) => {

      // console.log('Nil Return API Response', res);

      this.nilReturnList = res?.data || res;   // adjust based on response structure
      // this.nilReturnId = this.nilReturnList.length > 0 ? this.nilReturnList[0].id : null; // assuming one nil return per seek
      console.log('Nil return list', this.nilReturnList, 'Selected nil return ID');
      

    },
    error: (err) => {
      console.error('Error fetching nil returns', err);
    }
  });

}
editNilReturn(data: any) {

  this.selectedNilReturnId = data.id;
  this.editRemark = data.remark;

}

updateNilReturn() {

  const payload = {
    action: 'update',
    id: this.selectedNilReturnId,
    seek: this.selectedProposalForEditNilReturns?.id,
    user: sessionStorage.getItem('user_id'),
    remark: this.editRemark
  };

  this.api.postAPI('/transaction/seek/nil-return/', payload)
    .subscribe({
      next: (res: any) => {

        this.selectedNilReturnId = null;
        this.editRemark = '';

        this.getNilReturns(this.selectedProposalForEditNilReturns?.id || 0);

      },
      error: (err) => {
        console.error(err);
        this.editNilReturnModal = false;
      }
    });

}

selectedNilReturnForDelete: any = null;
confirmDeleteNilReturn(data: any) {

  this.selectedNilReturnForDelete = data;
  this.showDeleteDialog = true;

}

deleteNilReturnIfPopUpThenUseThis() {
  if (!this.selectedNilReturnForDelete) return;


  // if (confirm(`Are you sure you want to delete this NIL Return?`)) {

    const payload = {
      action: 'delete',
      // id: data.id
       id: this.selectedNilReturnForDelete.id
    };

    const sub = this.api.postAPI('/transaction/seek/nil-return/', payload)
      .subscribe({
        next: (res: any) => {

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'NIL Return deleted successfully'
          });
          this.showDeleteDialog = false;
          this.selectedNilReturnForDelete = null;
          this.getNilReturns(this.selectedProposalForEditNilReturns?.id || 0);

        },
        error: (err: any) => {

          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to delete NIL Return'
          });

          console.error('Delete NIL Return error:', err);
        }
      });

    this.subscriptions.add(sub);
  // }

}
deleteNilReturn(data: any) {
  // if (!this.selectedNilReturnForDelete) return;


  // if (confirm(`Are you sure you want to delete this NIL Return?`)) {

    const payload = {
      action: 'delete',
      id: data.id
      //  id: this.selectedNilReturnForDelete.id
    };

    const sub = this.api.postAPI('/transaction/seek/nil-return/', payload)
      .subscribe({
        next: (res: any) => {

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'NIL Return deleted successfully'
          });
          this.showDeleteDialog = false;
          this.selectedNilReturnForDelete = null;
          this.getNilReturns(this.selectedProposalForEditNilReturns?.id || 0);

        },
        error: (err: any) => {

          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to delete NIL Return'
          });

          console.error('Delete NIL Return error:', err);
        }
      });

    this.subscriptions.add(sub);
  // }

}
selectedFiles: File[] = [];
isDragging = false;

// --- Drag & Drop ---
onDragOver(event: DragEvent): void {
  event.preventDefault();
  this.isDragging = true;
}

onDragLeave(event: DragEvent): void {
  this.isDragging = false;
}

onDrop(event: DragEvent): void {
  event.preventDefault();
  this.isDragging = false;
  const files = event.dataTransfer?.files;
  if (files) this.addFiles(Array.from(files));
}

onFileSelected(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (input.files) this.addFiles(Array.from(input.files));
  input.value = ''; // reset so same file can be re-added
}

addFiles(files: File[]): void {
  const maxSize = 10 * 1024 * 1024; // 10MB
  files.forEach(file => {
    if (file.size > maxSize) {
      this.messageService.add({
        severity: 'warn',
        summary: 'File Too Large',
        detail: `${file.name} exceeds 10MB and was skipped.`
      });
      return;
    }
    // Avoid duplicates
    const exists = this.selectedFiles.some(f => f.name === file.name && f.size === file.size);
    if (!exists) this.selectedFiles.push(file);
  });
}

removeFile(index: number): void {
  this.selectedFiles.splice(index, 1);
}

formatFileSize(bytes: number): string {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}

getFileIcon(filename: string): string {
  const ext = filename.split('.').pop()?.toLowerCase();
  const iconMap: Record<string, string> = {
    pdf: 'pi pi-file-pdf text-danger',
    doc: 'pi pi-file-word text-primary',
    docx: 'pi pi-file-word text-primary',
    xls: 'pi pi-file-excel text-success',
    xlsx: 'pi pi-file-excel text-success',
    png: 'pi pi-image text-warning',
    jpg: 'pi pi-image text-warning',
    jpeg: 'pi pi-image text-warning',
  };
  return iconMap[ext || ''] || 'pi pi-file text-secondary';
}

// Reminder panel state
showReminderPanel = false;
reminderDirectorates:any;
reminderMessage = '';
reminderSubmitted = false;
isSendingReminder = false;

toggleReminderPanel(): void {
  this.showReminderPanel = !this.showReminderPanel;
  if (!this.showReminderPanel) {
    this.resetReminder();
  }
}

cancelReminder(): void {
  this.showReminderPanel = false;
  this.resetReminder();
}

resetReminder(): void {
  this.reminderDirectorates = '';
  this.reminderMessage = '';
  this.reminderSubmitted = false;
}

sendReminder(): void {
  this.reminderSubmitted = true;

  // Validate
  if (!this.reminderDirectorates?.length || !this.reminderMessage?.trim()) {
    return;
  }

  this.isSendingReminder = true;

  // const payload = {
  //   directorates: this.reminderDirectorates,
  //   message: this.reminderMessage.trim()
  // };
  const payload = {
    // unit_id: this.reminderDirectorates,
    unit_id: this.reminderDirectorates[0],
    message: this.reminderMessage.trim(),
    context_data: {
      module: 'seek_proposal',
       seek_id: this.selectedProposalForEdit.id,
      scheme_id: this.schemeID
    }
  };


  const sub = this.api.postAPI('/notification/send-reminder/', payload).subscribe({
    next: (res: any) => {
      this.isSendingReminder = false;
      this.showReminderPanel = false;
      this.resetReminder();

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Reminder sent successfully'
      });
    },
    error: (err: any) => {
      this.isSendingReminder = false;

      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: err?.error?.detail || 'Failed to send reminder'
      });

      console.error('Reminder error:', err);
    }
  });

  this.subscriptions.add(sub);
}
}



export interface Proposal {
  [x: string]: any;
  id: number;
  isInitiator: boolean;
  isRecommender: boolean;
  isApprover: boolean;
  proposal_name: string;
  code: string;
  status: number;
  organisation: string;
  category: string;
  releaseDate: string | null;
  coordinated_agency: string;
  technology_domain: string;
  title: string;
  nodal_officer: string;
  problem_statement: string;
  challenge_brief: string;
  prototype_development: string;
  requirement: string;
  functional_advantages: string;
  domestic: string;
  substitution: string;
  preliminary_scope: string;
  competitive_solution: string;
  potential_market: string;
  risk_assessment: string;
  mpo_qty: string;
  ip_value: string | null;
  pds: string | null;
  pru: string | null;
  priority: string | null;
  proposalStep: number;
  created_on: string;
  modifiedOn: string;
  createdBy: number;
  modifiedBy: number;
  approved_by: number | null;
  selected?: any;
  release_date?: string;
  proposal_step?: any;
  next_proposal_step_id?: any,
  valuation?: string,
  launchStatus?: string,
  challenge_status?: string,
  ip_status?: string
  current_proposal_step?: number
}